<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header tour-form-header">
        <span v-if="mData.viewMode == 'create'">Thêm mới tour</span>
        <span v-if="mData.viewMode == 'update'">Cập nhật tour</span>
        <span v-if="mData.viewMode == 'detail'">Chi tiết tour</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-form-item label="Tên tour" prop="ten_tour">
                <el-input
                  v-model="mData.dataForm.ten_tour"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  placeholder="Nhập tên tour"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Tên đoàn" prop="ten_doan">
                <el-input
                  v-model="mData.dataForm.ten_doan"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  placeholder="Nhập tên đoàn"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <el-form-item
                label="Thời gian bắt đầu"
                prop="thoi_gian_bat_dau"
                :error="fn_validateTourTime()"
                class="label-required"
              >
                <el-date-picker
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataForm.thoi_gian_bat_dau"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                  @change="fn_validateTourTime(), changeTourTimeStart()"
                  :picker-options="pickerOptionsTourTimeStart"
                  ref="startDate"
                ></el-date-picker>
              </el-form-item>
              <!--<span v-bind:class="{'message-error message-error-show': !!mData.dataDefault.tourTimeErrorMessage, 'message-error': !mData.dataDefault.tourTimeErrorMessage}" v-text="mData.dataDefault.tourTimeErrorMessage"></span>-->
            </b-col>
            <b-col md="3">
              <el-form-item
                label="Thời gian kết thúc"
                prop="thoi_gian_ket_thuc"
                :error="fn_validateTourTime()"
                class="label-required"
              >
                <el-date-picker
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataForm.thoi_gian_ket_thuc"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                  @change="fn_validateTourTime(), changeTourTimeEnd()"
                  :picker-options="pickerOptionsTourTimeEnd"
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="3" v-show="mData.viewMode != 'create'">
              <el-form-item label="Trạng thái" prop="da_hoan_thanh">
                <el-checkbox
                  v-model="mData.dataForm.da_hoan_thanh"
                  :disabled="mData.viewMode == 'detail'"
                  >Hoàn thành</el-checkbox
                >
              </el-form-item>
            </b-col>
          </b-row>

          <!-- tab -->
          <div class="tour-tabs mt-2">
            <div class="tour-tabs__nav">
              <div
                :class="[
                  'tour-tabs__item',
                  { active: tab.activeTab == 'dia-diem' },
                ]"
                @click="fn_clickTab('dia-diem')"
              >
                <span class="title-tab-required">Địa điểm</span>
              </div>
              <div
                :class="[
                  'tour-tabs__item',
                  { active: tab.activeTab == 'hanh-trinh' },
                ]"
                @click="fn_clickTab('hanh-trinh')"
              >
                <span class="title-tab-required">Hành trình</span>
              </div>
              <div
                :class="[
                  'tour-tabs__item',
                  { active: tab.activeTab == 'so-luong-khach' },
                ]"
                @click="fn_clickTab('so-luong-khach')"
              >
                <span class="title-tab-required">Số lượng khách</span>
              </div>
              <div
                :class="[
                  'tour-tabs__item',
                  { active: tab.activeTab == 'thong-tin-o-to' },
                ]"
                @click="fn_clickTab('thong-tin-o-to')"
              >
                Thông tin ô tô
              </div>
              <div
                :class="[
                  'tour-tabs__item',
                  { active: tab.activeTab == 'khach-san' },
                ]"
                @click="fn_clickTab('khach-san')"
              >
                Khách sạn/Nhà hàng
              </div>
              <div
                :class="[
                  'tour-tabs__item',
                  { active: tab.activeTab == 'anh-cua-tour' },
                ]"
                @click="fn_clickTab('anh-cua-tour')"
              >
                Ảnh của tour
              </div>
              <div
                :class="[
                  'tour-tabs__item',
                  { active: tab.activeTab == 'ho-so-tour' },
                ]"
                @click="fn_clickTab('ho-so-tour')"
              >
                Hồ sơ tour
              </div>
              <div
                :class="[
                  'tour-tabs__item',
                  { active: tab.activeTab == 'khach-du-lich' },
                ]"
                @click="fn_clickTab('khach-du-lich')"
              >
                Khách du lịch
              </div>
              <div
                :class="[
                  'tour-tabs__item',
                  { active: tab.activeTab == 'huong-dan-vien' },
                ]"
                @click="fn_clickTab('huong-dan-vien')"
              >
                Hướng dẫn viên
              </div>
              <div
                :class="[
                  'tour-tabs__item',
                  { active: tab.activeTab == 'noi-dung' },
                ]"
                @click="fn_clickTab('noi-dung')"
              >
                Nội dung
              </div>
            </div>
            <div class="tour-tabs__content">
              <!-- Tab: Địa điểm -->
              <div v-if="tab.activeTab == 'dia-diem'">
                <b-row>
                  <b-col md="8">
                    <el-form-item
                      label="Địa điểm tổ chức tour"
                      prop="dia_diem.dia_diem"
                    >
                      <el-input
                        ref="dia_diem.dia_diem"
                        v-model="mData.dataForm.dia_diem.dia_diem"
                        :disabled="mData.viewMode == 'detail'"
                        clearable
                        placeholder="Nhập địa điểm tổ chức tour"
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="4">
                    <el-form-item
                      label="Tỉnh/Thành phố"
                      prop="dia_diem.province_id"
                    >
                      <el-select
                        ref="dia_diem.province_id"
                        v-model="mData.dataForm.dia_diem.province_id"
                        placeholder="Chọn"
                        :disabled="mData.viewMode == 'detail'"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listProvince"
                          :key="item.id"
                          :label="item.type + ' ' + item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <el-checkbox
                      v-model="mData.dataPropMapDiaDiem.showMap"
                      :disabled="mData.viewMode == 'detail'"
                      >Vị trí trên bản đồ</el-checkbox
                    >
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <!-- <map-component
                        :prop-data-map="mData.dataPropMapDiaDiem"
                        v-if="mData.dataPropMapDiaDiem.showMap"
                        :prop-disabled="mData.viewMode == 'detail'"
                      ></map-component> -->
                    <mapbox-component
                      :id="'map-dia-diem-tour'"
                      :viewMode="mData.viewMode"
                      @update="fn_getDataFromMapDiaDiem"
                      :cordinatesValue="mData.mapDataDiaDiem.value"
                      v-if="mData.dataPropMapDiaDiem.showMap"
                    ></mapbox-component>
                  </b-col>
                </b-row>
              </div>

              <!-- Tab: Hành trình -->
              <div v-if="tab.activeTab == 'hanh-trinh'">
                <b-row>
                  <b-col md="12">
                    <el-button
                      type="info"
                      plain
                      @click="fn_openModalHanhTrinh('create')"
                      v-if="mData.viewMode != 'detail'"
                      >Thêm hành trình</el-button
                    >
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <div class="col-md-12">
                    <el-timeline>
                      <el-timeline-item
                        v-for="(item, index) in mData.dataForm.hanh_trinh"
                        :key="index"
                        color="#3598DC"
                        :timestamp="
                          fn_formatterDatetime(
                            null,
                            null,
                            item.thoi_gian_bat_dau,
                            null
                          ) +
                          ' - ' +
                          fn_formatterDatetime(
                            null,
                            null,
                            item.thoi_gian_ket_thuc,
                            null
                          )
                        "
                        placement="top"
                      >
                        <b-card class="mb-0">
                          <div
                            slot="header"
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                              width: 100%;
                            "
                          >
                            {{ item.tieu_de }}
                            <div class="card-header-actions">
                              <el-button
                                type="info"
                                plain
                                @click="fn_openModalHanhTrinh('detail', index)"
                                icon="fa fa-eye"
                                v-b-popover.hover.left="'Chi tiết'"
                              ></el-button>
                              <el-button
                                type="info"
                                plain
                                @click="fn_openModalHanhTrinh('update', index)"
                                icon="el-icon-edit"
                                v-b-popover.hover.left="'Cập nhật'"
                                v-if="mData.viewMode != 'detail'"
                              ></el-button>
                              <el-button
                                type="info"
                                plain
                                @click="fn_handleHanhTrinh('delete', index)"
                                icon="el-icon-delete"
                                v-b-popover.hover.left="'Xóa'"
                                v-if="mData.viewMode != 'detail'"
                              ></el-button>
                            </div>
                          </div>
                          <div>
                            <div>
                              <span class="bold-500">Địa điểm bắt đầu:</span>
                              {{ item.dia_diem.dia_diem }}
                            </div>
                            <div v-show="item.dia_diem_dich.dia_diem">
                              <span class="bold-500">Địa điểm kết thúc:</span>
                              {{ item.dia_diem_dich.dia_diem }}
                            </div>
                            <div>
                              <span class="bold-500">Nội dung:</span>
                            </div>
                            <div>
                              <html-component
                                :prop-data="item.noi_dung"
                                :key="mData.timelineHanhTrinh.reloadNoiDung"
                              ></html-component>
                            </div>
                          </div>
                        </b-card>
                      </el-timeline-item>
                    </el-timeline>
                  </div>
                </b-row>
              </div>

              <!-- Tab: Số lượng khách -->
              <div v-if="tab.activeTab == 'so-luong-khach'">
                <b-row>
                  <b-col md="3">
                    <el-form-item
                      label="Tổng số khách"
                      prop="so_luong_khach.so_luong"
                    >
                      <el-input-number
                        v-model="mData.dataForm.so_luong_khach.so_luong"
                        disabled
                        clearable
                        :min="0"
                      ></el-input-number>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item
                      label="Số người lớn"
                      prop="so_luong_khach.nguoi_lon"
                    >
                      <el-input-number
                        ref="so_luong_khach.so_luong"
                        v-model="mData.dataForm.so_luong_khach.nguoi_lon"
                        :disabled="mData.viewMode == 'detail'"
                        @change="fn_soLuongKhachChanged()"
                        clearable
                        :min="0"
                      ></el-input-number>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item
                      label="Trẻ em từ 5 đến 15 tuổi"
                      prop="so_luong_khach.tre_5_15"
                    >
                      <el-input-number
                        v-model="mData.dataForm.so_luong_khach.tre_5_15"
                        :disabled="mData.viewMode == 'detail'"
                        @change="fn_soLuongKhachChanged()"
                        clearable
                        :min="0"
                      ></el-input-number>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item
                      label="Trẻ em dưới 5 tuổi"
                      prop="so_luong_khach.tre_duoi_5"
                    >
                      <el-input-number
                        v-model="mData.dataForm.so_luong_khach.tre_duoi_5"
                        :disabled="mData.viewMode == 'detail'"
                        @change="fn_soLuongKhachChanged()"
                        :min="0"
                      ></el-input-number>
                    </el-form-item>
                  </b-col>
                </b-row>
              </div>

              <!-- Tab: Thông tin ô tô -->
              <div v-if="tab.activeTab == 'thong-tin-o-to'">
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Biển số xe" prop="oto.bien_so_xe">
                      <el-input
                        v-model="mData.dataForm.oto.bien_so_xe"
                        :disabled="mData.viewMode == 'detail'"
                        clearable
                        placeholder="Nhập biển số xe"
                      ></el-input>
                    </el-form-item>
                  </b-col>

                  <b-col md="6">
                    <el-form-item label="Tên tài xế" prop="oto.tai_xe.ho_ten">
                      <el-input
                        v-model="mData.dataForm.oto.tai_xe.ho_ten"
                        :disabled="mData.viewMode == 'detail'"
                        clearable
                        placeholder="Nhập tên tài xế"
                      ></el-input>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item
                      label="Số điện thoại tài xế"
                      prop="oto.tai_xe.dien_thoai"
                    >
                      <el-input
                        v-model="mData.dataForm.oto.tai_xe.dien_thoai"
                        :disabled="mData.viewMode == 'detail'"
                        clearable
                        placeholder="Nhập số điện thoại"
                      ></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
              </div>

              <!-- Tab: Khách sạn/Nhà hàng -->
              <div v-if="tab.activeTab == 'khach-san'">
                <b-row>
                  <b-col md="12">
                    <el-button
                      type="info"
                      plain
                      @click="fn_openModalKhachSan('create')"
                      v-if="mData.viewMode != 'detail'"
                      >Thêm khách sạn</el-button
                    >
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <div class="col-md-12">
                    <el-table
                      :data="mData.dataForm.khach_san"
                      border
                      max-height="440"
                      style="width: 100%; display: grid"
                    >
                      <el-table-column
                        prop="ten"
                        label="Tên khách sạn"
                        width="auto"
                        min-width="200"
                      ></el-table-column>

                      <el-table-column
                        prop="ten_nguoi_quan_ly"
                        label="Tên người quản lý"
                        width="150"
                      ></el-table-column>

                      <el-table-column
                        prop="dien_thoai"
                        label="Điện thoại"
                        width="100"
                        align="center"
                      ></el-table-column>

                      <el-table-column
                        prop="dia_chi.dia_chi"
                        label="Địa chỉ"
                        width="150"
                      ></el-table-column>

                      <el-table-column
                        label="Thao tác"
                        align="center"
                        width="150px"
                      >
                        <template slot-scope="scope">
                          <el-button
                            size="mini"
                            @click="
                              fn_openModalKhachSan('update', scope.$index)
                            "
                            v-b-popover.hover.left="'Cập nhật'"
                            v-if="mData.viewMode != 'detail'"
                          >
                            <i class="icon-pencil icons"></i>
                          </el-button>
                          <el-button
                            size="mini"
                            @click="
                              fn_openModalKhachSan('detail', scope.$index)
                            "
                            v-b-popover.hover.left="'Chi tiết'"
                          >
                            <i class="fa fa-eye"></i>
                          </el-button>
                          <el-button
                            size="mini"
                            @click="fn_handleKhachSan('delete', scope.$index)"
                            v-b-popover.hover.left="'Xóa'"
                            v-if="mData.viewMode != 'detail'"
                          >
                            <i class="icon-trash icons"></i>
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </b-row>
                <b-row class="mt-3">
                  <b-col md="12">
                    <el-button
                      type="info"
                      plain
                      @click="fn_openModalNhaHang('create')"
                      v-if="mData.viewMode != 'detail'"
                      >Thêm nhà hàng</el-button
                    >
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <div class="col-md-12">
                    <el-table
                      :data="mData.dataForm.nha_hang"
                      border
                      max-height="440"
                      style="width: 100%; display: grid"
                    >
                      <el-table-column
                        prop="ten"
                        label="Tên nhà hàng"
                        width="auto"
                        min-width="200"
                      ></el-table-column>
                      <el-table-column
                        prop="ten_nguoi_quan_ly"
                        label="Tên người quản lý"
                        width="150"
                      ></el-table-column>

                      <el-table-column
                        prop="dien_thoai"
                        label="Điện thoại"
                        width="100"
                        align="center"
                      ></el-table-column>

                      <el-table-column
                        prop="dia_chi.dia_chi"
                        label="Địa chỉ"
                        width="150"
                      ></el-table-column>

                      <el-table-column
                        label="Thao tác"
                        align="center"
                        width="150px"
                      >
                        <template slot-scope="scope">
                          <el-button
                            size="mini"
                            @click="fn_openModalNhaHang('update', scope.$index)"
                            v-b-popover.hover.left="'Cập nhật'"
                            v-if="mData.viewMode != 'detail'"
                          >
                            <i class="icon-pencil icons"></i>
                          </el-button>
                          <el-button
                            size="mini"
                            @click="fn_openModalNhaHang('detail', scope.$index)"
                            v-b-popover.hover.left="'Chi tiết'"
                          >
                            <i class="fa fa-eye"></i>
                          </el-button>
                          <el-button
                            size="mini"
                            @click="fn_handleNhaHang('delete', scope.$index)"
                            v-b-popover.hover.left="'Xóa'"
                            v-if="mData.viewMode != 'detail'"
                          >
                            <i class="icon-trash icons"></i>
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </b-row>
              </div>

              <!-- Tab: Ảnh của tour -->
              <div v-if="tab.activeTab == 'anh-cua-tour'">
                <b-row>
                  <b-col md="4">
                    <el-form-item class="mb-0" label="Ảnh đại diện">
                      <el-upload
                        action
                        :auto-upload="false"
                        list-type="picture-card"
                        :limit="mData.fileUploadOption.AnhDaiDien.limit"
                        :accept="mData.fileUploadOption.AnhDaiDien.accept"
                        :on-change="fn_uploadChangeAnhDaiDien"
                        :on-preview="fn_uploadPreviewAnhDaiDien"
                        :on-remove="fn_uploadRemoveAnhDaiDien"
                        :on-exceed="fn_uploadExceedAnhDaiDien"
                        :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                        :disabled="mData.viewMode == 'detail'"
                        :class="[
                          mData.fileUploadOption.AnhDaiDien.fileList.length > 0
                            ? 'hidden-icon-upload'
                            : '',
                        ]"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                      <el-dialog
                        :close-on-click-modal="true"
                        :visible.sync="
                          mData.fileUploadOption.AnhDaiDien.dialogVisible
                        "
                        width="60%"
                        top="51px"
                        title="Chi tiết"
                      >
                        <img
                          width="100%"
                          :src="
                            mData.fileUploadOption.AnhDaiDien.dialogImageUrl
                          "
                          alt
                        />
                      </el-dialog>
                    </el-form-item>
                  </b-col>
                  <b-col md="8">
                    <el-form-item class="mb-0" label="Ảnh tour">
                      <el-upload
                        action
                        :auto-upload="false"
                        list-type="picture-card"
                        :limit="mData.fileUploadOption.AnhTour.limit"
                        :accept="mData.fileUploadOption.AnhTour.accept"
                        :on-change="fn_uploadChangeAnhTour"
                        :on-preview="fn_uploadPreviewAnhTour"
                        :on-remove="fn_uploadRemoveAnhTour"
                        :on-exceed="fn_uploadExceedAnhTour"
                        multiple
                        :file-list="mData.fileUploadOption.AnhTour.fileList"
                        :disabled="mData.viewMode == 'detail'"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                      <el-dialog
                        :close-on-click-modal="true"
                        :visible.sync="
                          mData.fileUploadOption.AnhTour.dialogVisible
                        "
                        width="60%"
                        top="51px"
                        title="Chi tiết"
                      >
                        <img
                          width="100%"
                          :src="mData.fileUploadOption.AnhTour.dialogImageUrl"
                          alt
                        />
                      </el-dialog>
                    </el-form-item>
                  </b-col>
                </b-row>
              </div>

              <!-- Tab: Hồ sơ tour -->
              <div v-if="tab.activeTab == 'ho-so-tour'">
                <b-row>
                  <b-col md="6">
                    <el-form-item class="mb-0" label>
                      <el-upload
                        action
                        :auto-upload="false"
                        list-type="text"
                        :limit="mData.fileUploadOption.HoSoTour.limit"
                        :accept="mData.fileUploadOption.HoSoTour.accept"
                        :on-change="fn_uploadChangeHoSoTour"
                        :on-preview="fn_uploadPreviewHoSoTour"
                        :on-remove="fn_uploadRemoveHoSoTour"
                        :on-exceed="fn_uploadExceedHoSoTour"
                        :file-list="mData.fileUploadOption.HoSoTour.fileList"
                        :disabled="mData.viewMode == 'detail'"
                        multiple
                      >
                        <el-button
                          size="small"
                          type="info"
                          plain
                          v-if="mData.viewMode != 'detail'"
                        >
                          <i class="fa fa-upload"></i> Upload file
                        </el-button>
                      </el-upload>
                    </el-form-item>
                  </b-col>
                </b-row>
              </div>

              <!-- Tab: Khách du lịch -->
              <div v-if="tab.activeTab == 'khach-du-lich'">
                <b-row class="mt-0">
                  <b-col md="12" class="mb-2"
                    >Danh sách khách du lịch đã xác nhận</b-col
                  >
                  <div class="col-md-12">
                    <el-table
                      v-if="showwTable"
                      :data="mData.dataDefault.listKhachDuLichDaXacNhanTable"
                      border
                      max-height="440"
                      style="width: 100%; display: grid"
                    >
                      <el-table-column
                        prop="ho_ten.ho_ten"
                        label="Họ tên"
                        width="auto"
                        min-width="170"
                      >
                        <template slot-scope="scope">
                          {{
                            scope.row.ho_ten &&
                            scope.row.ho_ten.ho_ten &&
                            scope.row.ho_ten.ho_ten.trim() != ""
                              ? scope.row.ho_ten.ho_ten
                              : "Chưa có thông tin"
                          }}
                          {{ scope.row.isTruongDoan ? "(Trưởng đoàn)" : "" }}
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop="so_the"
                        label="Số thẻ"
                        width="150"
                        align="right"
                      >
                        <template slot-scope="scope">
                          {{
                            scope.row.so_the &&
                            scope.row.so_the.length == 11 &&
                            scope.row.so_the.toString().substring(0, 2) == "84"
                              ? "Chưa có thông tin"
                              : scope.row.so_the
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="email" label="Email" width="130">
                        <template slot-scope="scope">
                          {{
                            scope.row.email
                              ? scope.row.email
                              : "Chưa có thông tin"
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="dien_thoai"
                        label="Điện thoại"
                        width="110"
                        align="right"
                      >
                        <template slot-scope="scope">
                          {{
                            scope.row.so_the &&
                            scope.row.so_the.length == 11 &&
                            scope.row.so_the.toString().substring(0, 2) == "84"
                              ? scope.row.so_the
                              : scope.row.dien_thoai
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="ngay_sinh.ngay_sinh"
                        label="Ngày sinh"
                        :formatter="fn_formatterDate"
                        width="100"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        prop="quoc_tich.ten_quoc_tich"
                        label="Quốc tịch"
                        width="100"
                      >
                        <template slot-scope="scope">
                          {{
                            scope.row.quoc_tich &&
                            scope.row.quoc_tich.ten_quoc_tich
                              ? scope.row.quoc_tich.ten_quoc_tich
                              : "Chưa có thông tin"
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Thao tác"
                        align="center"
                        width="125px"
                        v-if="mData.viewMode != 'detail'"
                      >
                        <template slot-scope="scope">
                          <el-button
                            size="mini"
                            @click="fn_selectTruongDoan(scope.row.id)"
                            v-b-popover.hover.left="
                              scope.row.isTruongDoan
                                ? 'Bỏ chọn trưởng đoàn'
                                : 'Chọn trưởng đoàn'
                            "
                          >
                            <i
                              class="el-icon-user"
                              v-if="!scope.row.isTruongDoan"
                            ></i>
                            <i
                              class="el-icon-user-solid text-primary"
                              v-if="scope.row.isTruongDoan"
                            ></i>
                          </el-button>
                          <el-button
                            size="mini"
                            @click="fn_deleteKhachDuLichDaXacNhan(scope.$index)"
                            v-b-popover.hover.left="'Xóa'"
                          >
                            <i class="icon-trash icons"></i>
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </b-row>

                <b-row v-if="mData.viewMode != 'detail'" class="mt-3">
                  <b-col md="4">
                    <el-form-item label="Định danh khách - SĐT/Mã thẻ">
                      <el-select
                        v-model="mData.dataDefault.itemKhachDuLich"
                        :disabled="mData.viewMode == 'detail'"
                        clearable
                        filterable
                        placeholder="Nhập từ khóa để tìm kiếm"
                        no-data-text="Chưa có dữ liệu"
                        :filter-method="fn_remoteGetListKhachDuLich"
                        @keyup.enter.native="fn_enterFindKhachDuLich()"
                        @change="
                          fn_addKhachDuLich(mData.dataDefault.itemKhachDuLich)
                        "
                      >
                        <!-- <el-option
                            :label="ho_ten.ho_ten+ ' - Email: ' + (email?email:'')+' - SĐT: ' +(dien_thoai?dien_thoai:'')"
                          ></el-option> -->
                        <el-option
                          v-for="item in mData.dataDefault.listKhachDuLich"
                          :key="item.id"
                          :label="
                            (item.ho_ten &&
                            item.ho_ten.ho_ten &&
                            item.ho_ten.ho_ten.trim() != ''
                              ? item.ho_ten.ho_ten
                              : 'Chưa có thông tin') +
                            ' - Email: ' +
                            (item.email ? item.email : 'Chưa có thông tin') +
                            ' - SĐT: ' +
                            (item.dien_thoai ? item.dien_thoai : '')
                          "
                          :value="item"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="4">
                    <el-form-item label="Số giấy tờ">
                      <el-select
                        v-model="mData.dataDefault.itemKhachDuLich2"
                        :disabled="mData.viewMode == 'detail'"
                        clearable
                        filterable
                        placeholder="Nhập từ khóa để tìm kiếm"
                        no-data-text="Chưa có dữ liệu"
                        :filter-method="fn_remoteGetListKhachDuLich2"
                        @keyup.enter.native="fn_enterFindKhachDuLich2()"
                        @change="
                          fn_addKhachDuLich2(mData.dataDefault.itemKhachDuLich2)
                        "
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listKhachDuLich2"
                          :key="item.id"
                          :label="
                            (item.ho_ten &&
                            item.ho_ten.ho_ten &&
                            item.ho_ten.ho_ten.trim() != ''
                              ? item.ho_ten.ho_ten
                              : 'Chưa có thông tin') +
                            ' - Email: ' +
                            (item.email ? item.email : '') +
                            ' - SĐT: ' +
                            (item.dien_thoai ? item.dien_thoai : '')
                          "
                          :value="item"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <!-- <b-col md="3">

                    </b-col>-->

                  <b-col md="2">
                    <el-form-item label="Import từ file excel">
                      <el-upload
                        action
                        :auto-upload="false"
                        list-type="text"
                        :limit="mData.fileUploadOption.DsKhachDuLich.limit"
                        :accept="mData.fileUploadOption.DsKhachDuLich.accept"
                        :on-change="fn_uploadChangeDsKhachDuLich"
                        :on-exceed="fn_uploadExceedDsKhachDuLich"
                        :file-list="
                          mData.fileUploadOption.DsKhachDuLich.fileList
                        "
                        :disabled="mData.viewMode == 'detail'"
                        multiple
                      >
                        <el-button size="small" type="info" plain>
                          <i class="fa fa-upload"></i> Upload file
                        </el-button>
                      </el-upload>
                    </el-form-item>
                  </b-col>
                  <b-col md="2">
                    <el-form-item label="File excel mẫu">
                      <b-link
                        class="el-button el-button--info el-button--small is-plain"
                        :href="aExtension.urlFilesTemplate.DsKhachDuLich"
                      >
                        <i class="fa fa-download"></i> Tải file
                      </b-link>
                    </el-form-item>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12" class="mb-2">
                    Danh sách khách du lịch chờ xác nhận</b-col
                  >
                  <div class="col-md-12">
                    <el-table
                      v-if="showwTable"
                      :data="mData.dataDefault.listKhachDuLichTable"
                      border
                      max-height="440"
                      style="width: 100%; display: grid"
                    >
                      <el-table-column
                        prop="ho_ten.ho_ten"
                        label="Họ tên"
                        width="auto"
                        min-width="170"
                      >
                        <template slot-scope="scope">
                          {{
                            scope.row.ho_ten &&
                            scope.row.ho_ten.ho_ten &&
                            scope.row.ho_ten.ho_ten.trim() != ""
                              ? scope.row.ho_ten.ho_ten
                              : "Chưa có thông tin"
                          }}
                          {{ scope.row.isTruongDoan ? "(Trưởng đoàn)" : "" }}
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop="so_the"
                        label="Số thẻ"
                        width="150"
                        align="right"
                      >
                        <template slot-scope="scope">
                          {{
                            scope.row.so_the &&
                            scope.row.so_the.length == 11 &&
                            scope.row.so_the.toString().substring(0, 2) == "84"
                              ? "Chưa có thông tin"
                              : scope.row.so_the
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="email" label="Email" width="130">
                        <template slot-scope="scope">
                          {{
                            scope.row.email
                              ? scope.row.email
                              : "Chưa có thông tin"
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="dien_thoai"
                        label="Điện thoại"
                        width="110"
                        align="right"
                      >
                        <template slot-scope="scope">
                          {{
                            scope.row.so_the &&
                            scope.row.so_the.length == 11 &&
                            scope.row.so_the.toString().substring(0, 2) == "84"
                              ? scope.row.so_the
                              : scope.row.dien_thoai
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="ngay_sinh.ngay_sinh"
                        label="Ngày sinh"
                        :formatter="fn_formatterDate"
                        width="100"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        prop="quoc_tich.ten_quoc_tich"
                        label="Quốc tịch"
                        width="100"
                      >
                        <template slot-scope="scope">
                          {{
                            scope.row.quoc_tich &&
                            scope.row.quoc_tich.ten_quoc_tich
                              ? scope.row.quoc_tich.ten_quoc_tich
                              : "Chưa có thông tin"
                          }}
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="Thao tác"
                        align="center"
                        width="125px"
                        v-if="mData.viewMode != 'detail'"
                      >
                        <template slot-scope="scope">
                          <el-button
                            size="mini"
                            @click="fn_selectTruongDoan(scope.row.id)"
                            v-b-popover.hover.left="
                              scope.row.isTruongDoan
                                ? 'Bỏ chọn trưởng đoàn'
                                : 'Chọn trưởng đoàn'
                            "
                          >
                            <!-- <i class="icon-user icons"></i> -->
                            <i
                              class="el-icon-user"
                              v-if="!scope.row.isTruongDoan"
                            ></i>
                            <i
                              class="el-icon-user-solid text-primary"
                              v-if="scope.row.isTruongDoan"
                            ></i>
                          </el-button>
                          <el-button
                            size="mini"
                            @click="fn_deleteKhachDuLich(scope.$index)"
                            v-b-popover.hover.left="'Xóa'"
                          >
                            <i class="icon-trash icons"></i>
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </b-row>

                <!-- <b-row class="mt-1">
                    <b-col md="12" class="mb-2">Khách du lịch chưa có thẻ</b-col>
                    <div class="col-md-12">
                      <el-table
                        :data="mData.dataDefault.listKhachDuLichKhongTaiKhoanTable"
                        border
                        max-height="440"
                        style="width: 100%; display: grid;"
                      >
                        <el-table-column
                          prop="ho_ten.ho_ten"
                          label="Họ tên"
                          width="auto"
                          min-width="130"
                        >
                          <template slot-scope="scope">
                            {{ scope.row.ho_ten && scope.row.ho_ten.ho_ten && scope.row.ho_ten.ho_ten.trim() != "" ? scope.row.ho_ten.ho_ten : " Chưa có thông tin" }}
                          </template>
                        </el-table-column>

                        <el-table-column prop="email" label="Email" width="130">
                          <template slot-scope="scope">
                            {{ scope.row.email ? scope.row.email : " Chưa có thông tin" }}
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="dien_thoai"
                          label="Điện thoại"
                          width="130"
                          align="right"
                        >
                          <template slot-scope="scope">
                            {{ scope.row.dien_thoai ? scope.row.dien_thoai : " Chưa có thông tin" }}
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="ngay_sinh.ngay_sinh"
                          label="Ngày sinh"
                          :formatter="fn_formatterDate"
                          width="100"
                          align="center"
                        ></el-table-column>
                        <el-table-column
                          prop="quoc_tich.ten_quoc_tich"
                          label="Quốc tịch"
                          width="100"
                        >
                          <template slot-scope="scope">
                            {{ scope.row.quoc_tich && scope.row.quoc_tich.ten_quoc_tich ? scope.row.ho_ten.ho_ten : " Chưa có thông tin" }}
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="Thao tác"
                          align="center"
                          width="100px"
                          v-if="mData.viewMode != 'detail'"
                        >
                          <template slot-scope="scope">
                            <el-button
                              size="mini"
                              @click="fn_selectTruongDoan(scope.row.id)"
                              v-b-popover.hover.left="'Chọn trưởng đoàn'"
                            >
                              <i class="el-icon-user" v-if="!scope.row.isTruongDoan"></i>
                              <i class="el-icon-user-solid text-primary" v-if="scope.row.isTruongDoan"></i>
                            </el-button>
                            <el-button
                              size="mini"
                              @click="fn_deleteKhachDuLichChuaCoTK(scope.$index)"
                              v-b-popover.hover.left="'Xóa'"
                            >
                              <i class="icon-trash icons"></i>
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </b-row> -->
                <b-row
                  class="mt-1"
                  v-if="
                    mData.dataDefault.listKhachDuLichExcel &&
                    mData.dataDefault.listKhachDuLichExcel.length > 0
                  "
                >
                  <b-col md="12" class="mb-2"
                    >Danh sách khách du lịch từ file excel</b-col
                  >
                  <div class="col-md-12">
                    <el-table
                      :data="mData.dataDefault.listKhachDuLichExcel"
                      border
                      max-height="440"
                      style="width: 100%; display: grid"
                    >
                      <el-table-column
                        prop="ho_ten.ho_ten"
                        label="Họ tên"
                        width="auto"
                        min-width="150"
                      ></el-table-column>
                      <el-table-column
                        prop="so_the"
                        label="Số thẻ"
                        width="150"
                        align="right"
                      ></el-table-column>
                      <el-table-column
                        prop="email"
                        label="Email"
                        width="100"
                      ></el-table-column>
                      <el-table-column
                        prop="dien_thoai"
                        label="Điện thoại"
                        width="100"
                        align="right"
                      ></el-table-column>
                      <el-table-column
                        prop="ngay_sinh.ngay_sinh"
                        label="Ngày sinh"
                        :formatter="fn_formatterDate"
                        width="100"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        prop="quoc_tich.ten_quoc_tich"
                        label="Quốc tịch"
                        width="100"
                      ></el-table-column>
                      <el-table-column
                        label="Thao tác"
                        align="center"
                        width="100px"
                        v-if="mData.viewMode != 'detail'"
                      >
                        <template slot-scope="scope">
                          <!-- <el-button
                              size="mini"
                              @click="fn_selectTruongDoan(scope.row.id)"
                              v-b-popover.hover.left="'Chọn trưởng đoàn'"
                            >
                              <i class="el-icon-user" v-if="!scope.row.isTruongDoan"></i>
                              <i class="el-icon-user-solid text-primary" v-if="scope.row.isTruongDoan"></i>
                            </el-button>-->
                          <el-button
                            size="mini"
                            @click="fn_deleteKhachDuLichExcel(scope.$index)"
                            v-b-popover.hover.left="'Xóa'"
                          >
                            <i class="icon-trash icons"></i>
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </b-row>
              </div>

              <!-- Tab: Hướng dẫn viên -->
              <div v-if="tab.activeTab == 'huong-dan-vien'">
                <b-row>
                  <!-- <b-col md="12" class="mb-2">Danh sách hướng dẫn viên đã xác nhận</b-col>
                    <div class="col-md-12">
                      <el-table
                        :data="mData.dataDefault.listHuongDanVienDaXacNhanTable"
                        border
                        max-height="440"
                        style="width: 100%; display: grid;"
                      >
                        <el-table-column
                          prop="ho_ten.ho_ten"
                          label="Họ tên"
                          width="auto"
                          min-width="150"
                        ></el-table-column>
                        <el-table-column
                          prop="the_hdv.so_the"
                          label="Số thẻ HDV"
                          width="150"
                          align="right"
                        ></el-table-column>

                        <el-table-column prop="email" label="Email" width="150"></el-table-column>
                        <el-table-column
                          prop="dien_thoai"
                          label="Điện thoại"
                          width="100"
                          align="right"
                        ></el-table-column>
                        <el-table-column
                          prop="ngay_sinh.ngay_sinh"
                          label="Ngày sinh"
                          width="100"
                          align="center"
                          :formatter="fn_formatterDate"
                        ></el-table-column>
                        <el-table-column
                          prop="quoc_tich.ten_quoc_tich"
                          label="Quốc tịch"
                          width="100"
                        ></el-table-column>
                        <el-table-column label="Thao tác" align="center" width="80px">
                          <template slot-scope="scope">
                            <el-button
                              size="mini"
                              @click="fn_openModalViTriHDV('detail',scope.row.id, scope.row.ho_ten.ho_ten)"
                              v-b-popover.hover.left="'Xem vị trí'"
                            >
                              <i class="icon-location-pin icons"></i>
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div> -->
                  <b-col md="12">
                    <p style="font-size: 15px">
                      Để thêm hướng dẫn viên cho tour, vui lòng vào mục "<b-link
                        href="javascript:"
                        @click="goToTourTicket"
                        >Phiếu điều tour</b-link
                      >"
                    </p>
                  </b-col>
                </b-row>
              </div>

              <!-- Tab: Nội dung -->
              <div v-if="tab.activeTab == 'noi-dung'">
                <b-row>
                  <b-col md="12">
                    <el-form-item label prop="noi_dung">
                      <editor-component
                        :prop-data-editor="mData.dataForm"
                        :prop-data-editor-key="'noi_dung'"
                        :prop-data-editor-disabled="mData.viewMode == 'detail'"
                        v-if="tab.activeTab == 'noi-dung'"
                      ></editor-component>
                    </el-form-item>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>

          <el-form-item class="text-center mt-3">
            <el-button @click="fn_go()" type="info" plain>Quay lại</el-button>
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
              >Thêm mới</el-button
            >
            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
              >Cập nhật</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- modal Hành trình -->
    <el-dialog
      :close-on-click-modal="false"
      title="Hành trình"
      :visible.sync="mData.dialog.HanhTrinh"
      width="80%"
      top="51px"
      font-size="13px"
    >
      <div class="card-body scroll-y-80vh">
        <el-form
          :model="mData.dataFormHanhTrinh"
          :rules="mData.validFormHanhTrinh"
          ref="myFormHanhTrinh"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <el-form-item label="Tiêu đề" prop="tieu_de">
                <el-input
                  v-model="mData.dataFormHanhTrinh.tieu_de"
                  :disabled="mData.dataDefault.HanhTrinh.viewMode == 'detail'"
                  clearable
                  placeholder="Nhập tiêu đề"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <el-form-item
                label="Thời gian bắt đầu"
                prop="thoi_gian_bat_dau"
                :error="fn_validateHanhTrinhTime('from')"
              >
                <el-date-picker
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataFormHanhTrinh.thoi_gian_bat_dau"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.dataDefault.HanhTrinh.viewMode == 'detail'"
                  @change="fn_validateHanhTrinhTime('from')"
                ></el-date-picker>
                <span
                  v-bind:class="{
                    'message-error message-error-show':
                      !!mData.dataDefault.thoiGianBatDauHanhTrinhErrorMessage,
                    'message-error':
                      !mData.dataDefault.thoiGianBatDauHanhTrinhErrorMessage,
                  }"
                  v-text="mData.dataDefault.thoiGianBatDauHanhTrinhErrorMessage"
                ></span>
              </el-form-item>
            </b-col>

            <b-col md="3">
              <el-form-item
                label="Thời gian kết thúc"
                prop="thoi_gian_ket_thuc"
                :error="fn_validateHanhTrinhTime('to')"
              >
                <el-date-picker
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataFormHanhTrinh.thoi_gian_ket_thuc"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.dataDefault.HanhTrinh.viewMode == 'detail'"
                  @change="fn_validateHanhTrinhTime('to')"
                ></el-date-picker>
                <span
                  v-bind:class="{
                    'message-error message-error-show':
                      !!mData.dataDefault.thoiGianKetThucHanhTrinhErrorMessage,
                    'message-error':
                      !mData.dataDefault.thoiGianKetThucHanhTrinhErrorMessage,
                  }"
                  v-text="
                    mData.dataDefault.thoiGianKetThucHanhTrinhErrorMessage
                  "
                ></span>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Nội dung" prop="noi_dung">
                <el-input
                  type="textarea"
                  :rows="6"
                  v-model="mData.dataFormHanhTrinh.noi_dung"
                  :disabled="mData.dataDefault.HanhTrinh.viewMode == 'detail'"
                  placeholder="Nhập nội dung"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Địa điểm sự kiện">
                <el-radio-group
                  v-model="mData.dataDefault.HanhTrinh.diaDiemMode"
                  @change="
                    fn_changeDiaDiem(mData.dataDefault.HanhTrinh.diaDiemMode)
                  "
                  :disabled="mData.dataDefault.HanhTrinh.viewMode == 'detail'"
                >
                  <el-radio label="one" border>Một địa điểm</el-radio>
                  <el-radio label="two" border>Hai địa điểm</el-radio>
                </el-radio-group>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              :class="[
                mData.dataDefault.HanhTrinh.diaDiemMode == 'two'
                  ? 'col-md-6'
                  : 'col-md-12',
              ]"
            >
              <b-row>
                <b-col md="12">
                  <el-form-item
                    label="Địa điểm bắt đầu"
                    prop="dia_diem.dia_diem"
                  >
                    <el-input
                      v-model="mData.dataFormHanhTrinh.dia_diem.dia_diem"
                      :disabled="
                        mData.dataDefault.HanhTrinh.viewMode == 'detail'
                      "
                      clearable
                      placeholder="Nhập địa điểm bắt đầu"
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="6">
                  <el-form-item
                    label="Tỉnh/Thành phố"
                    prop="dia_diem.province_id"
                  >
                    <el-select
                      v-model="mData.dataFormHanhTrinh.dia_diem.province_id"
                      placeholder="Chọn"
                      :disabled="
                        mData.dataDefault.HanhTrinh.viewMode == 'detail'
                      "
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listProvince"
                        :key="item.id"
                        :label="item.type + ' ' + item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <el-checkbox
                    v-model="mData.dataPropMapHanhTrinhDiaDiemBatDau.showMap"
                    :disabled="mData.dataDefault.HanhTrinh.viewMode == 'detail'"
                    >Vị trí trên bản đồ</el-checkbox
                  >
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <!-- <map-component
                    :prop-data-map="mData.dataPropMapHanhTrinhDiaDiemBatDau"
                    v-if="mData.dataPropMapHanhTrinhDiaDiemBatDau.showMap"
                    :prop-disabled="mData.dataDefault.HanhTrinh.viewMode == 'detail'"
                    :key="mData.dataPropMapHanhTrinhDiaDiemBatDau.reload"
                  ></map-component> -->
                  <mapbox-component
                    :id="'map-hanh-trinh-bat-dau'"
                    :viewMode="mData.dataDefault.HanhTrinh.viewMode"
                    @update="fn_getDataFromMapHanhTrinhDiaDiemBatDau"
                    :cordinatesValue="mData.mapDataHanhTrinhDiaDiemBatDau.value"
                    v-if="mData.dataPropMapHanhTrinhDiaDiemBatDau.showMap"
                  ></mapbox-component>
                </b-col>
              </b-row>
            </b-col>

            <b-col
              md="6"
              style="border-left: 1px solid #ccc"
              v-show="mData.dataDefault.HanhTrinh.diaDiemMode == 'two'"
            >
              <b-row>
                <b-col md="12">
                  <el-form-item
                    label="Địa điểm kết thúc"
                    prop="dia_diem_dich.dia_diem"
                  >
                    <el-input
                      v-model="mData.dataFormHanhTrinh.dia_diem_dich.dia_diem"
                      :disabled="
                        mData.dataDefault.HanhTrinh.viewMode == 'detail'
                      "
                      clearable
                      placeholder="Nhập địa điểm kết thúc"
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="6">
                  <el-form-item
                    label="Tỉnh/Thành phố"
                    prop="dia_diem_dich.province_id"
                  >
                    <el-select
                      v-model="
                        mData.dataFormHanhTrinh.dia_diem_dich.province_id
                      "
                      placeholder="Chọn"
                      :disabled="
                        mData.dataDefault.HanhTrinh.viewMode == 'detail'
                      "
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listProvince"
                        :key="item.id"
                        :label="item.type + ' ' + item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <el-checkbox
                    v-model="mData.dataPropMapHanhTrinhDiaDiemKetThuc.showMap"
                    :disabled="mData.dataDefault.HanhTrinh.viewMode == 'detail'"
                    >Vị trí trên bản đồ</el-checkbox
                  >
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <!-- <map-component
                    :prop-data-map="mData.dataPropMapHanhTrinhDiaDiemKetThuc"
                    v-if="mData.dataPropMapHanhTrinhDiaDiemKetThuc.showMap"
                    :prop-disabled="mData.dataDefault.HanhTrinh.viewMode == 'detail'"
                    :key="mData.dataPropMapHanhTrinhDiaDiemKetThuc.reload"
                  ></map-component> -->
                  <mapbox-component
                    :id="'map-hanh-trinh-ket-thuc'"
                    :viewMode="mData.dataDefault.HanhTrinh.viewMode"
                    @update="fn_getDataFromMapHanhTrinhDiaDiemKetThuc"
                    :cordinatesValue="
                      mData.mapDataHanhTrinhDiaDiemKetThuc.value
                    "
                    v-if="mData.dataPropMapHanhTrinhDiaDiemKetThuc.showMap"
                  ></mapbox-component>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              v-ladda
              @click="fn_handleHanhTrinh('create')"
              v-if="mData.dataDefault.HanhTrinh.viewMode == 'create'"
              >Thêm mới</el-button
            >
            <el-button
              type="info"
              plain
              v-ladda
              @click="fn_handleHanhTrinh('update')"
              v-if="mData.dataDefault.HanhTrinh.viewMode == 'update'"
              >Cập nhật</el-button
            >
            <el-button @click="mData.dialog.HanhTrinh = false" type="info" plain
              >Đóng</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- modal Khách sạn -->
    <el-dialog
      :close-on-click-modal="false"
      title="Khách sạn"
      :visible.sync="mData.dialog.KhachSan"
      width="60%"
      top="51px"
      font-size="13px"
    >
      <div class="card-body scroll-y-80vh">
        <el-form
          :model="mData.dataFormKhachSan"
          :rules="mData.validFormKhachSan"
          ref="myFormKhachSan"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="8">
              <el-form-item label="Tên khách sạn" prop="ten">
                <el-input
                  v-model="mData.dataFormKhachSan.ten"
                  clearable
                  :disabled="mData.dataDefault.KhachSan.viewMode == 'detail'"
                  placeholder="Nhập tên khách sạn"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Tên người quản lý" prop="ten_nguoi_quan_ly">
                <el-input
                  v-model="mData.dataFormKhachSan.ten_nguoi_quan_ly"
                  clearable
                  :disabled="mData.dataDefault.KhachSan.viewMode == 'detail'"
                  placeholder="Nhập tên người quản lý"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Địa chỉ" prop="dia_chi.dia_chi">
                <el-input
                  v-model="mData.dataFormKhachSan.dia_chi.dia_chi"
                  clearable
                  :disabled="mData.dataDefault.KhachSan.viewMode == 'detail'"
                  placeholder="Nhập địa chỉ"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <el-form-item label="Tỉnh/Thành phố" prop="dia_chi.province_id">
                <el-select
                  v-model="mData.dataFormKhachSan.dia_chi.province_id"
                  placeholder="Chọn"
                  :disabled="mData.dataDefault.KhachSan.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listProvince"
                    :key="item.id"
                    :label="item.type + ' ' + item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>

            <b-col md="4">
              <el-form-item label="Điện thoại" prop="dien_thoai">
                <el-input
                  type="text"
                  v-model="mData.dataFormKhachSan.dien_thoai"
                  clearable
                  :disabled="mData.dataDefault.KhachSan.viewMode == 'detail'"
                  placeholder="Nhập số điện thoại"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-checkbox
                v-model="mData.dataPropMapKhachSan.showMap"
                :disabled="mData.dataDefault.KhachSan.viewMode == 'detail'"
                >Vị trí trên bản đồ</el-checkbox
              >
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <!-- <map-component
                :prop-data-map="mData.dataPropMapKhachSan"
                v-if="mData.dataPropMapKhachSan.showMap"
                :prop-disabled="mData.dataDefault.KhachSan.viewMode == 'detail'"
                :key="mData.dataPropMapKhachSan.reload"
              ></map-component> -->
              <mapbox-component
                :id="'map-khach-san'"
                :viewMode="mData.dataDefault.KhachSan.viewMode"
                @update="fn_getDataFromMapKhachSan"
                :cordinatesValue="mData.mapDataKhachSan.value"
                v-if="mData.dataPropMapKhachSan.showMap"
              ></mapbox-component>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              v-ladda
              @click="fn_handleKhachSan('create')"
              v-if="mData.dataDefault.KhachSan.viewMode == 'create'"
              >Thêm mới</el-button
            >
            <el-button
              type="info"
              plain
              v-ladda
              @click="fn_handleKhachSan('update')"
              v-if="mData.dataDefault.KhachSan.viewMode == 'update'"
              >Cập nhật</el-button
            >
            <el-button @click="mData.dialog.KhachSan = false" type="info" plain
              >Đóng</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- modal Nhà Hàng -->
    <el-dialog
      :close-on-click-modal="false"
      title="Nhà Hàng"
      :visible.sync="mData.dialog.NhaHang"
      width="60%"
      top="51px"
    >
      <div class="card-body scroll-y-80vh">
        <el-form
          :model="mData.dataFormNhaHang"
          :rules="mData.validFormNhaHang"
          ref="myFormNhaHang"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="8">
              <el-form-item label="Tên nhà hàng" prop="ten">
                <el-input
                  v-model="mData.dataFormNhaHang.ten"
                  clearable
                  :disabled="mData.dataDefault.NhaHang.viewMode == 'detail'"
                  placeholder="Nhập tên nhà hàng"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Tên người quản lý" prop="ten_nguoi_quan_ly">
                <el-input
                  v-model="mData.dataFormNhaHang.ten_nguoi_quan_ly"
                  clearable
                  :disabled="mData.dataDefault.NhaHang.viewMode == 'detail'"
                  placeholder="Nhập tên người quản lý"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Địa chỉ" prop="dia_chi.dia_chi">
                <el-input
                  v-model="mData.dataFormNhaHang.dia_chi.dia_chi"
                  :disabled="mData.dataDefault.NhaHang.viewMode == 'detail'"
                  clearable
                  placeholder="Nhập địa chỉ"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <el-form-item label="Tỉnh/Thành phố" prop="dia_chi.province_id">
                <el-select
                  v-model="mData.dataFormNhaHang.dia_chi.province_id"
                  placeholder="Chọn"
                  :disabled="mData.dataDefault.NhaHang.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listProvince"
                    :key="item.id"
                    :label="item.type + ' ' + item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Điện thoại" prop="dien_thoai">
                <el-input
                  type="text"
                  v-model="mData.dataFormNhaHang.dien_thoai"
                  clearable
                  :disabled="mData.dataDefault.NhaHang.viewMode == 'detail'"
                  placeholder="Nhập số điện thoại"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <el-checkbox
                v-model="mData.dataPropMapNhaHang.showMap"
                :disabled="mData.dataDefault.NhaHang.viewMode == 'detail'"
                >Vị trí trên bản đồ</el-checkbox
              >
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <!-- <map-component
                :prop-data-map="mData.dataPropMapNhaHang"
                v-if="mData.dataPropMapNhaHang.showMap"
                :prop-disabled="mData.dataDefault.NhaHang.viewMode == 'detail'"
                :key="mData.dataPropMapNhaHang.reload"
              ></map-component> -->
              <mapbox-component
                :id="'map-nha-hang'"
                :viewMode="mData.dataDefault.NhaHang.viewMode"
                @update="fn_getDataFromMapNhaHang"
                :cordinatesValue="mData.mapDataNhaHang.value"
                v-if="mData.dataPropMapNhaHang.showMap"
              ></mapbox-component>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              v-ladda
              @click="fn_handleNhaHang('create')"
              v-if="mData.dataDefault.NhaHang.viewMode == 'create'"
              >Thêm mới</el-button
            >
            <el-button
              type="info"
              plain
              v-ladda
              @click="fn_handleNhaHang('update')"
              v-if="mData.dataDefault.NhaHang.viewMode == 'update'"
              >Cập nhật</el-button
            >
            <el-button @click="mData.dialog.NhaHang = false" type="info" plain
              >Đóng</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- modal excel khách du lịch -->
    <el-dialog
      :close-on-click-modal="false"
      title="Danh sách upload khách du lịch"
      :visible.sync="mData.dialogKhachDuLich.visible"
      width="90%"
      top="51px"
    >
      <div class="card-body">
        <el-table
          :data="mData.dialogKhachDuLich.list"
          border
          max-height="400"
          style="width: 100%"
        >
          <el-table-column
            prop="excel_stt"
            label="STT"
            align="center"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="excel_ho_ten"
            label="Họ tên"
            min-width="150"
            width="auto"
          >
            <template slot-scope="scope">
              <span
                :class="
                  fn_formatterTableExcelKhachDuLich(
                    'excel_ho_ten',
                    scope.row.excel_ho_ten
                  )
                "
                >{{ scope.row.excel_ho_ten }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="excel_dien_thoai"
            label="Điện thoại"
            align="right"
            width="100"
          >
            <template slot-scope="scope">
              <span
                :class="
                  fn_formatterTableExcelKhachDuLich(
                    'excel_dien_thoai',
                    scope.row.excel_dien_thoai
                  )
                "
                >{{ scope.row.excel_dien_thoai }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="excel_ma_ms"
            label="Mã MS"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="excel_email"
            label="Email"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="excel_gioi_tinh"
            label="Giới tính"
            width="60"
          ></el-table-column>
          <el-table-column
            prop="excel_ngay_sinh"
            label="Ngày sinh"
            align="right"
            width="60"
          >
            <template slot-scope="scope">
              <span
                :class="
                  fn_formatterTableExcelKhachDuLich(
                    'excel_ngay_sinh',
                    scope.row.excel_ngay_sinh,
                    scope.row.excel_thang_sinh,
                    scope.row.excel_nam_sinh
                  )
                "
                >{{ scope.row.excel_ngay_sinh }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="excel_thang_sinh"
            label="Tháng sinh"
            align="right"
            width="60"
          >
            <template slot-scope="scope">
              <span
                :class="
                  fn_formatterTableExcelKhachDuLich(
                    'excel_thang_sinh',
                    scope.row.excel_ngay_sinh,
                    scope.row.excel_thang_sinh,
                    scope.row.excel_nam_sinh
                  )
                "
                >{{ scope.row.excel_thang_sinh }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="excel_nam_sinh"
            label="Năm sinh"
            align="right"
            width="60"
          >
            <template slot-scope="scope">
              <span
                :class="
                  fn_formatterTableExcelKhachDuLich(
                    'excel_nam_sinh',
                    scope.row.excel_nam_sinh
                  )
                "
                >{{ scope.row.excel_nam_sinh }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="excel_dia_chi"
            label="Địa chỉ"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="excel_province_name"
            label="Tỉnh/Thành phố"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="excel_ten_quoc_tich"
            label="Quốc tịch"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="excel_loai_giay_to"
            label="Loại giấy tờ"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="excel_so_giay_to"
            label="Số giấy tờ"
            align="right"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="excel_noi_cap"
            label="Nơi cấp"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="excel_ngay_cap"
            label="Ngày cấp"
            align="right"
            width="60"
          >
            <template slot-scope="scope">
              <span
                :class="
                  fn_formatterTableExcelKhachDuLich(
                    'excel_ngay_cap',
                    scope.row.excel_ngay_cap,
                    scope.row.excel_thang_cap,
                    scope.row.excel_nam_cap
                  )
                "
                >{{ scope.row.excel_ngay_cap }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="excel_thang_cap"
            label="Tháng cấp"
            align="right"
            width="60"
          >
            <template slot-scope="scope">
              <span
                :class="
                  fn_formatterTableExcelKhachDuLich(
                    'excel_thang_cap',
                    scope.row.excel_ngay_cap,
                    scope.row.excel_thang_cap,
                    scope.row.excel_nam_cap
                  )
                "
                >{{ scope.row.excel_thang_cap }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="excel_nam_cap"
            label="Năm cấp"
            align="right"
            width="60"
          >
            <template slot-scope="scope">
              <span
                :class="
                  fn_formatterTableExcelKhachDuLich(
                    'excel_nam_cap',
                    scope.row.excel_ngay_cap,
                    scope.row.excel_thang_cap,
                    scope.row.excel_nam_cap
                  )
                "
                >{{ scope.row.excel_nam_cap }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="excel_ngay_het_han"
            label="Ngày hết hạn"
            align="right"
            width="80"
          >
            <template slot-scope="scope">
              <span
                :class="
                  fn_formatterTableExcelKhachDuLich(
                    'excel_ngay_het_han',
                    scope.row.excel_ngay_het_han,
                    scope.row.excel_thang_het_han,
                    scope.row.excel_nam_het_han
                  )
                "
                >{{ scope.row.excel_ngay_het_han }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="excel_thang_het_han"
            label="Tháng hết hạn"
            align="right"
            width="80"
          >
            <template slot-scope="scope">
              <span
                :class="
                  fn_formatterTableExcelKhachDuLich(
                    'excel_thang_het_han',
                    scope.row.excel_ngay_het_han,
                    scope.row.excel_thang_het_han,
                    scope.row.excel_nam_het_han
                  )
                "
                >{{ scope.row.excel_thang_het_han }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="excel_nam_het_han"
            label="Năm hết hạn"
            align="right"
            width="80"
          >
            <template slot-scope="scope">
              <span
                :class="
                  fn_formatterTableExcelKhachDuLich(
                    'excel_nam_het_han',
                    scope.row.excel_ngay_het_han,
                    scope.row.excel_thang_het_han,
                    scope.row.excel_nam_het_han
                  )
                "
                >{{ scope.row.excel_nam_het_han }}</span
              >
            </template>
          </el-table-column>
        </el-table>
        <b-row class="mt-3 text-center">
          <b-col md="12">
            <el-button
              type="info"
              plain
              v-ladda
              @click="fn_addValueKhachDuLich"
              :disabled="mData.dialogKhachDuLich.hasError"
              >Thêm mới</el-button
            >
          </b-col>
        </b-row>
      </div>
    </el-dialog>

    <!-- modal vị trí hướng dẫn viên đã xác nhận -->
    <el-dialog
      :close-on-click-modal="false"
      :title="'Vị trí của HDV ' + mData.dialogViTriHDV.title"
      :visible.sync="mData.dialogViTriHDV.visible"
      width="60%"
      top="51px"
    >
      <div class="card-body">
        <b-row>
          <b-col>
            <map-component
              :prop-data-map="mData.dataPropMapViTriHDV"
              v-if="mData.dataPropMapViTriHDV.showMap"
              :prop-disabled="true"
              :key="mData.dataPropMapViTriHDV.reload"
            ></map-component>
          </b-col>
        </b-row>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
// Card header form
.tour-form-header {
  padding: 8px 15px;
}

// Tab layout flex
.tour-tabs {
  display: flex;
}
.tour-tabs__nav {
  width: 250px;
  min-width: 250px;
  margin-right: 15px;
  background-color: #f0f3f5;
  border-radius: 4px;
  padding: 8px;
}
.tour-tabs__item {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 13px;
  margin-bottom: 2px;
  &:hover {
    background-color: #e4e7ea;
  }
  &.active {
    background-color: #20a8d8;
    color: #fff;
  }
}
.tour-tabs__content {
  flex: 1;
  min-width: 0;
}

.title-tab-required {
  &::before {
    content: "*";
    color: #f56c6c;
    margin-right: 5px;
  }
}
.message-error {
  display: none;
  color: #f56c6c;
  font-size: 12px;
  padding-top: 2px;
  line-height: 1;
  word-break: normal;
}
.message-error.message-error-show {
  display: block;
}
</style>

<script>
import ValidService from "../../../service/ValidService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import mushroom from "../../../service/api/dulich-api";
// import DistrictApi from "../../../moduleApi/DistrictApi";
import TourModel from "./TourModel";
import MapComponent from "../../../component/MapComponent";
import MapboxComponent from "@/component/MapboxComponent";
import EditorComponent from "../../../component/EditorComponent";
import HtmlComponent from "../../../component/HtmlComponent";

export default {
  components: {
    MapComponent,
    EditorComponent,
    HtmlComponent,
    MapboxComponent,
  },
  data() {
    return {
      aElement: MethodService.element,
      aExtension: ExtensionService,
      showwTable: true,
      pickerOptionsTourTimeStart: {
        disabledDate(time) {
          return false;
        },
      },
      pickerOptionsTourTimeEnd: {
        disabledDate(time) {
          return false;
        },
      },
      tab: {
        index: 0,
        activeTab: "dia-diem",
      },
      data: {
        viewMode: "create",
        type: "",
      },
      mData: {
        viewMode: "create",
        viewModeDuplicate: false,
        moduleName: "Tour",
        dataDefault: {
          roles: DataService.rolesInForm,
          listProvince: [],
          listDistrict: [],
          listHuongDanVien: [],
          HanhTrinh: {
            viewMode: "create",
            indexModal: undefined,
            diaDiemMode: "one",
          },
          KhachSan: {
            viewMode: "create",
            indexModal: undefined,
          },
          NhaHang: {
            viewMode: "create",
            indexModal: undefined,
          },
          textFindKhachDuLich: "",
          listKhachDuLich: [],
          itemKhachDuLich: null,

          textFindKhachDuLich2: "",
          listKhachDuLich2: [],
          itemKhachDuLich2: null,
          listKhachDuLichTable: [],

          listKhachDuLichExcel: [],

          listKhachDuLichDaXacNhanTable: [],
          listKhachDuLichKhongTaiKhoanTable: [],

          textFindTruongDoan: "",
          listTruongDoan: [],
          itemTruongDoan: null,

          textFindTruongDoan2: "",
          listTruongDoan2: [],
          itemTruongDoan2: null,
          listTruongDoanTable: [],

          listHuongDanVienDaXacNhanTable: [],
          tourTimeErrorMessage: false,
        },
        dataForm: MethodService.copyObject(TourModel.dataForm),
        validForm: TourModel.validForm,

        dataFormHanhTrinh: MethodService.copyObject(
          TourModel.dataFormOther.hanh_trinh
        ),
        validFormHanhTrinh: TourModel.validFormOther.hanh_trinh,

        dataFormKhachSan: MethodService.copyObject(
          TourModel.dataFormOther.khach_san
        ),
        validFormKhachSan: TourModel.validFormOther.khach_san,

        dataFormNhaHang: MethodService.copyObject(
          TourModel.dataFormOther.nha_hang
        ),
        validFormNhaHang: TourModel.validFormOther.nha_hang,

        dialog: {
          HanhTrinh: false,
          KhachSan: false,
          NhaHang: false,
        },
        fileUploadOption: {
          AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          AnhTour: {
            limit: null,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          ThongTinDieuTour: {
            limit: null,
            accept: "",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          HoSoTour: {
            limit: null,
            accept: "",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          DsKhachDuLich: {
            limit: 10,
            accept: ".xlsx",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
        dataPropMapDiaDiem: {
          fn_addLatLng: this.fn_addLatLngDiaDiem,
          lat: "",
          lng: "",
          showMap: false,
          id: "MapDiaDiem",
        },
        dataPropMapHanhTrinhDiaDiemBatDau: {
          fn_addLatLng: this.fn_addLatLngHanhTrinhDiaDiemBatDau,
          lat: "",
          lng: "",
          showMap: false,
          type: "",
          id: "MapHanhTrinhDiaDiemBatDau",
          reload: 0,
        },
        dataPropMapHanhTrinhDiaDiemKetThuc: {
          fn_addLatLng: this.fn_addLatLngHanhTrinhDiaDiemKetThuc,
          lat: "",
          lng: "",
          showMap: false,
          type: "",
          id: "MapHanhTrinhDiaDiemKetThuc",
          reload: 0,
        },
        dataPropMapKhachSan: {
          fn_addLatLng: this.fn_addLatLngKhachSan,
          lat: "",
          lng: "",
          showMap: false,
          type: "",
          id: "MapKhachSan",
          reload: 0,
        },
        dataPropMapNhaHang: {
          fn_addLatLng: this.fn_addLatLngNhaHang,
          lat: "",
          lng: "",
          showMap: false,
          type: "",
          id: "MapNhaHang",
          reload: 0,
        },
        mapDataDiaDiem: {
          value: [105.850176, 21.0287797],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
        mapDataHanhTrinhDiaDiemBatDau: {
          value: [105.850176, 21.0287797],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
        mapDataHanhTrinhDiaDiemKetThuc: {
          value: [105.850176, 21.0287797],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
        mapDataKhachSan: {
          value: [105.850176, 21.0287797],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
        mapDataNhaHang: {
          value: [105.850176, 21.0287797],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
        mapDataViTriHDV: {
          value: [105.850176, 21.0287797],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
        excelKhachDuLich: MethodService.copyObject(TourModel.excelKhachDuLich),
        dialogKhachDuLich: {
          list: [],
          visible: false,
          hasError: false,
        },
        dialogViTriHDV: {
          visible: false,
          title: "",
        },
        dataPropMapViTriHDV: {
          fn_addLatLng: this.fn_addLatLngViTriHDV,
          lat: "",
          lng: "",
          showMap: true,
          id: "MapViTriHDV",
          reload: 0,
          updateLastTime: "",
        },
        timelineHanhTrinh: {
          reloadNoiDung: 0,
        },
      },
    };
  },
  methods: {
    goToTourTicket() {
      this.$router.push({ name: "Admin-PhieuDieuTour-list" });
    },
    changeTourTimeStart() {
      if (!this.mData.dataForm.thoi_gian_bat_dau) {
        this.pickerOptionsTourTimeEnd = {
          disabledDate(time) {
            return false;
          },
        };
        return;
      }
      const timeStart = new Date(this.mData.dataForm.thoi_gian_bat_dau);
      this.pickerOptionsTourTimeEnd = {
        disabledDate(time) {
          return time.getTime() < timeStart.getTime();
        },
      };
    },
    changeTourTimeEnd() {
      if (!this.mData.dataForm.thoi_gian_ket_thuc) {
        this.pickerOptionsTourTimeStart = {
          disabledDate(time) {
            return false;
          },
        };
        return;
      }
      const timeEnd = new Date(this.mData.dataForm.thoi_gian_ket_thuc);
      this.pickerOptionsTourTimeStart = {
        disabledDate(time) {
          return time.getTime() > timeEnd.getTime();
        },
      };
    },
    fn_submitForm(type) {
      // this.$store.commit("fn_initMap");
      this.$refs["myForm"].validate(async (valid, object) => {
        if (!valid) {
          window.toastr.warning("Một số trường chưa nhập đúng thông tin!");
          const arrKeyObject = Object.keys(object);
          if (
            arrKeyObject.includes("dia_diem.dia_diem") ||
            arrKeyObject.includes("dia_diem.province_id")
          ) {
            this.tab.index = 0;
            this.tab.activeTab = "dia-diem";
            setTimeout(() => {
              if (object["dia_diem.dia_diem"])
                this.$refs["dia_diem.dia_diem"].focus();
              else if (object["dia_diem.province_id"])
                this.$refs["dia_diem.province_id"].focus();
            }, 200);
          } else if (arrKeyObject.includes("so_luong_khach.so_luong")) {
            this.tab.index = 2;
            this.tab.activeTab = "so-luong-khach";
            setTimeout(() => {
              this.$refs["so_luong_khach.so_luong"].focus();
            }, 200);
          }
          MethodService.stopLadda();
          return false;
        }
        if (
          !this.mData.dataForm.hanh_trinh ||
          this.mData.dataForm.hanh_trinh.length === 0
        ) {
          this.tab.index = 1;
          this.tab.activeTab = "hanh-trinh";
          window.toastr.warning("Vui lòng thêm hành trình của Tour");
          MethodService.stopLadda();
          return false;
        }
        if (this.mData.dataForm.ten_tour) {
          this.mData.dataForm.ten_tour = this.mData.dataForm.ten_tour.trim();
        }
        if (this.mData.dataForm.ten_doan) {
          this.mData.dataForm.ten_doan = this.mData.dataForm.ten_doan.trim();
        }
        if (this.mData.dataFormHanhTrinh.dia_diem_dich.dia_diem) {
          this.mData.dataFormHanhTrinh.dia_diem_dich.dia_diem =
            this.mData.dataFormHanhTrinh.dia_diem_dich.dia_diem.trim();
        }

        if (this.mData.dataDefault.tourTimeErrorMessage) {
          window.toastr.warning(this.mData.dataDefault.tourTimeErrorMessage);
          this.$refs["startDate"].focus();
          document.body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
          MethodService.stopLadda();
          return false;
        }

        if (
          !this.mData.dataForm.so_luong_khach.so_luong ||
          this.mData.dataForm.so_luong_khach.so_luong == 0
        ) {
          window.toastr.warning("Vui lòng chọn số lượng khách!");
          this.fn_clickTab("so-luong-khach");
          this.tab.index = 2;
          MethodService.stopLadda();
          return false;
        }

        let data = MethodService.copyObject(this.mData.dataForm);
        if (data.noi_dung) {
          //replace http để lấy id ảnh
          data.noi_dung = MethodService.replaceURLImage(data.noi_dung);
        }
        if (!this.mData.dataPropMapDiaDiem.showMap) {
          data.dia_diem.lat = null;
          data.dia_diem.lng = null;
        } else {
          data.dia_diem.lat = this.mData.mapDataDiaDiem.value[1];
          data.dia_diem.lng = this.mData.mapDataDiaDiem.value[0];
        }
        if (type == "create") {
          if (this.mData.viewModeDuplicate) {
            delete data.id;
          }
          let tour = await mushroom.tour.createAsync(data);
          if (
            this.mData.dataDefault.listKhachDuLichExcel &&
            this.mData.dataDefault.listKhachDuLichExcel.length > 0
          ) {
            await mushroom.tour.importTouristsAsync({
              body: this.mData.dataDefault.listKhachDuLichExcel,
              params: { tourId: tour.result },
            });
          }
          this.fn_resetForm();
          this.fn_go(-1);
        }
        if (type == "update") {
          data.id = this.$router.currentRoute.params.id;
          console.log("data", data);
          await mushroom.tour.partialUpdateAsync(data);
          this.fn_go();
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
      if (this.$refs["myFormHanhTrinh"]) {
        this.fn_resetFormHanhTrinh();
      }
      if (this.$refs["myFormKhachSan"]) {
        this.fn_resetFormKhachSan();
      }
      if (this.$refs["myFormNhaHang"]) {
        this.fn_resetFormNhaHang();
      }
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.mData.fileUploadOption.AnhTour.fileList = [];
      this.mData.fileUploadOption.HoSoTour.fileList = [];
      this.mData.fileUploadOption.ThongTinDieuTour.fileList = [];
      this.mData.fileUploadOption.DsKhachDuLich.fileList = [];
      this.mData.dataForm.hanh_trinh = [];
      this.mData.dataForm.khach_san = [];
      this.mData.dataForm.nha_hang = [];
      this.mData.dataDefault.listKhachDuLichTable = [];
      this.mData.dataDefault.listKhachDuLichKhongTaiKhoanTable = [];
      this.mData.dataDefault.listKhachDuLichExcel = [];
      this.mData.mapDataDiaDiem.value[0] = 105.850176;
      this.mData.mapDataDiaDiem.value[1] = 21.0287797;
      this.mData.dataPropMapDiaDiem.showMap = false;
    },
    fn_resetFormHanhTrinh() {
      this.$refs["myFormHanhTrinh"].resetFields();
      this.mData.mapDataHanhTrinhDiaDiemBatDau.lng = 105.850176;
      this.mData.mapDataHanhTrinhDiaDiemBatDau.lat = 21.0287797;
      this.mData.dataPropMapHanhTrinhDiaDiemBatDau.showMap = false;
      this.mData.mapDataHanhTrinhDiaDiemKetThuc.lng = 105.850176;
      this.mData.mapDataHanhTrinhDiaDiemKetThuc.lat = 21.0287797;
      this.mData.dataPropMapHanhTrinhDiaDiemKetThuc.showMap = false;
    },
    fn_resetFormKhachSan() {
      this.$refs["myFormKhachSan"].resetFields();
      this.mData.mapDataKhachSan.value[0] = 105.850176;
      this.mData.mapDataKhachSan.value[1] = 21.0287797;
      this.mData.dataPropMapKhachSan.showMap = false;
    },
    fn_resetFormNhaHang() {
      this.$refs["myFormNhaHang"].resetFields();
      this.mData.mapDataNhaHang.value[0] = 105.850176;
      this.mData.mapDataNhaHang.value[1] = 21.0287797;
      this.mData.dataPropMapNhaHang.showMap = false;
    },
    fn_go() {
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
      });
    },
    async fn_getDataById(idTour) {
      let res = await mushroom.tour.findByIdAsync({ id: idTour });
      // let resNew = MethodService.checkDifferentObject(
      //   MethodService.copyObject(TourModel.dataForm),
      //   res.result
      // );
      let resNew = res.result;

      if (resNew.anh && resNew.anh.anh_dai_dien) {
        let data = {
          id: resNew.anh.anh_dai_dien,
          name: resNew.anh.anh_dai_dien,
          url: ExtensionService.urlImg + resNew.anh.anh_dai_dien,
        };
        this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
      }
      if (resNew.anh && resNew.anh.anh_tour) {
        let listFile = await mushroom.file.listAsync({
          limit: resNew.anh.anh_tour.length,
          filters: "id:in:" + resNew.anh.anh_tour.join(","),
        });
        let data = [];
        if (listFile && listFile.result) {
          data = listFile.result;
          data.map((item) => {
            item.url = ExtensionService.urlImg + item.id;
          });
        }
        this.mData.fileUploadOption.AnhTour.fileList = data;
      }

      if (resNew.scan && resNew.scan.thong_tin_dieu_tour) {
        let listFile = await mushroom.file.listAsync({
          limit: resNew.scan.thong_tin_dieu_tour.length,
          filters: "id:in:" + resNew.scan.thong_tin_dieu_tour.join(","),
        });
        let data = [];
        if (listFile && listFile.result) {
          data = listFile.result;
          data.map((item) => {
            item.url = ExtensionService.urlImg + item.id;
          });
        }
        this.mData.fileUploadOption.ThongTinDieuTour.fileList = data;
      }

      if (resNew.scan && resNew.scan.ho_so_tour) {
        let listFile = await mushroom.file.listAsync({
          limit: resNew.scan.ho_so_tour.length,
          filters: "id:in:" + resNew.scan.ho_so_tour.join(","),
        });
        let data = [];
        if (listFile && listFile.result) {
          data = listFile.result;
          data.map((item) => {
            item.url = ExtensionService.urlImg + item.id;
          });
        }
        this.mData.fileUploadOption.HoSoTour.fileList = data;
      }
      if (
        resNew.khach_du_lich_cho_xac_nhan_ids &&
        resNew.khach_du_lich_cho_xac_nhan_ids.length > 0
      ) {
        let listKhachDuLich = await mushroom.khach_du_lich.listAsync({
          limit: resNew.khach_du_lich_cho_xac_nhan_ids.length,
          filters: "id:in:" + resNew.khach_du_lich_cho_xac_nhan_ids.join(","),
        });
        this.mData.dataDefault.listKhachDuLichTable = listKhachDuLich.result;
        if (resNew.truong_doan && resNew.truong_doan.truong_doan_id) {
          this.fn_setTruongDoanStatus(
            this.mData.dataDefault.listKhachDuLichTable,
            resNew.truong_doan.truong_doan_id
          );
        }
      }
      if (resNew.truong_doan && resNew.truong_doan.truong_doan_id) {
        let listKhachDuLich = await mushroom.khach_du_lich.listAsync({
          limit: resNew.truong_doan.truong_doan_id.length,
          filters: "id=" + resNew.truong_doan.truong_doan_id,
        });
        this.mData.dataDefault.listTruongDoanTable = listKhachDuLich.result;
      }
      if (resNew.khach_du_lich_ids && resNew.khach_du_lich_ids.length > 0) {
        let listKhachDuLich = await mushroom.khach_du_lich.listAsync({
          limit: resNew.khach_du_lich_ids.length,
          filters: "id:in:" + resNew.khach_du_lich_ids.join(","),
        });
        this.mData.dataDefault.listKhachDuLichDaXacNhanTable =
          listKhachDuLich.result;

        if (resNew.truong_doan && resNew.truong_doan.truong_doan_id) {
          this.fn_setTruongDoanStatus(
            this.mData.dataDefault.listKhachDuLichDaXacNhanTable,
            resNew.truong_doan.truong_doan_id
          );
        }
      }
      // debugger
      if (
        resNew.danh_sach_khach_du_lich_khong_tai_khoan &&
        resNew.danh_sach_khach_du_lich_khong_tai_khoan.length > 0
      ) {
        this.mData.dataDefault.listKhachDuLichTable =
          this.mData.dataDefault.listKhachDuLichTable.concat(
            resNew.danh_sach_khach_du_lich_khong_tai_khoan
          );

        if (resNew.truong_doan && resNew.truong_doan.truong_doan_id) {
          this.fn_setTruongDoanStatus(
            this.mData.dataDefault.listKhachDuLichTable,
            resNew.truong_doan.truong_doan_id
          );
        }
      }
      if (resNew.huong_dan_vien_ids && resNew.huong_dan_vien_ids.length > 0) {
        let listHuongDanVien = await mushroom.huong_dan_vien.listAsync({
          limit: resNew.huong_dan_vien_ids.length,
          filters: "id:in:" + resNew.huong_dan_vien_ids.join(","),
        });
        for (var itemData in listHuongDanVien.result) {
          if (
            listHuongDanVien.result[itemData].ngay_sinh.ngay_sinh == undefined
          ) {
            listHuongDanVien.result[itemData].ngay_sinh.ngay_sinh = new Date(
              listHuongDanVien.result[itemData].ngay_sinh.nam,
              listHuongDanVien.result[itemData].ngay_sinh.thang - 1,
              listHuongDanVien.result[itemData].ngay_sinh.ngay
            ).toUTCString();
          }
        }
        this.mData.dataDefault.listHuongDanVienDaXacNhanTable =
          listHuongDanVien.result;
      }

      if (resNew.noi_dung) {
        resNew.noi_dung = MethodService.unreplaceURLImage(resNew.noi_dung);
      }
      if (resNew.dia_diem && resNew.dia_diem.lat && resNew.dia_diem.lng) {
        this.mData.mapDataDiaDiem.value[1] = resNew.dia_diem.lat;
        this.mData.mapDataDiaDiem.value[0] = resNew.dia_diem.lng;
        this.mData.dataPropMapDiaDiem.showMap = true;
      }

      this.mData.dataForm = resNew;
      console.log("this.mData.dataForm", this.mData.dataForm);
      if (this.mData.dataForm.danh_sach_khach_du_lich_khong_tai_khoan) {
        this.mData.dataForm.danh_sach_khach_du_lich_khong_tai_khoan.forEach(
          (item) => (item.key = MethodService.generateId(12))
        );
      } else {
        this.mData.dataForm.danh_sach_khach_du_lich_khong_tai_khoan = [];
      }
      if (this.mData.viewModeDuplicate == true) {
        this.fn_changeDataDefault();
      }
    },
    fn_setTruongDoanStatus(listData, id) {
      listData.forEach((element) => {
        if (id != null && element.id == id) {
          element.isTruongDoan = true;
        } else {
          element.isTruongDoan = false;
        }
      });
      this.showwTable = false;
      setTimeout(() => {
        this.showwTable = true;
      }, 10);
    },
    async fn_initDataDefault() {
      let Province = await mushroom.province.listAsync({ limit: 1000 });
      this.mData.dataDefault.listProvince = Province.result;
    },
    async fn_changeDataDefault() {
      this.mData.dataDefault.listKhachDuLich = [];
      this.mData.dataDefault.listKhachDuLichTable = [];
      this.mData.dataDefault.listKhachDuLich2 = [];
      this.mData.dataDefault.listKhachDuLichDaXacNhanTable = [];
      this.mData.dataDefault.listHuongDanVien = [];
      this.mData.dataDefault.listHuongDanVienDaXacNhanTable = [];
      this.mData.dataDefault.listKhachDuLichKhongTaiKhoanTable = [];
      this.mData.dataDefault.listTruongDoan = [];
      this.mData.dataDefault.listTruongDoan2 = [];
      this.mData.dataDefault.listTruongDoanTable = [];
      this.mData.dataForm.da_hoan_thanh = false;
      this.mData.dataForm.huong_dan_vien_ids = [];
      this.mData.dataForm.khach_du_lich_ids = [];
      this.mData.dataForm.khach_du_lich_cho_xac_nhan_ids = [];
      this.mData.dataForm.thoi_gian_bat_dau = null;
      this.mData.dataForm.thoi_gian_ket_thuc = null;
      delete this.mData.dataForm.id;
    },
    // hành trình
    fn_handleHanhTrinh(type, index) {
      if (type == "create") {
        this.$refs["myFormHanhTrinh"].validate(async (valid) => {
          if (!valid) {
            window.toastr.warning("Một số trường chưa nhập đúng thông tin");
            MethodService.stopLadda();
            return false;
          }
          if (this.mData.dataDefault.thoiGianBatDauHanhTrinhErrorMessag) {
            window.toastr.warning(
              this.mData.dataDefault.thoiGianBatDauHanhTrinhErrorMessage
            );
            MethodService.stopLadda();
            return false;
          }
          if (this.mData.dataDefault.thoiGianKetThucHanhTrinhErrorMessage) {
            window.toastr.warning(
              this.mData.dataDefault.thoiGianKetThucHanhTrinhErrorMessage
            );
            MethodService.stopLadda();
            return false;
          }

          let item = MethodService.copyObject(this.mData.dataFormHanhTrinh);
          if (!this.mData.dataPropMapHanhTrinhDiaDiemBatDau.showMap) {
            item.dia_diem.lat = null;
            item.dia_diem.lng = null;
            this.mData.dataPropMapHanhTrinhDiaDiemBatDau.lat = null;
            this.mData.dataPropMapHanhTrinhDiaDiemBatDau.lng = null;
          } else {
            item.dia_diem.lat =
              this.mData.mapDataHanhTrinhDiaDiemBatDau.value[1];
            item.dia_diem.lng =
              this.mData.mapDataHanhTrinhDiaDiemBatDau.value[0];
          }
          if (!this.mData.dataPropMapHanhTrinhDiaDiemKetThuc.showMap) {
            item.dia_diem_dich.lat = null;
            item.dia_diem_dich.lng = null;
            this.mData.dataPropMapHanhTrinhDiaDiemKetThuc.lat = null;
            this.mData.dataPropMapHanhTrinhDiaDiemKetThuc.lng = null;
          } else {
            item.dia_diem_dich.lat =
              this.mData.mapDataHanhTrinhDiaDiemKetThuc.value[1];
            item.dia_diem_dich.lng =
              this.mData.mapDataHanhTrinhDiaDiemKetThuc.value[0];
          }
          console.log("item create", item);
          this.mData.dataForm.hanh_trinh.push(item);
          this.fn_resetFormHanhTrinh();
          this.mData.dialog.HanhTrinh = false;
          MethodService.stopLadda();
        });
      }
      if (type == "update") {
        this.$refs["myFormHanhTrinh"].validate(async (valid) => {
          if (!valid) {
            window.toastr.warning("Một số trường chưa nhập đúng thông tin");
            MethodService.stopLadda();
            return false;
          }
          if (this.mData.dataDefault.thoiGianBatDauHanhTrinhErrorMessag) {
            window.toastr.warning(
              this.mData.dataDefault.thoiGianBatDauHanhTrinhErrorMessage
            );
            MethodService.stopLadda();
            return false;
          }
          if (this.mData.dataDefault.thoiGianKetThucHanhTrinhErrorMessage) {
            window.toastr.warning(
              this.mData.dataDefault.thoiGianKetThucHanhTrinhErrorMessage
            );
            MethodService.stopLadda();
            return false;
          }

          let item = MethodService.copyObject(this.mData.dataFormHanhTrinh);
          if (!this.mData.dataPropMapHanhTrinhDiaDiemBatDau.showMap) {
            item.dia_diem.lat = null;
            item.dia_diem.lng = null;
            this.mData.dataPropMapHanhTrinhDiaDiemBatDau.lat = null;
            this.mData.dataPropMapHanhTrinhDiaDiemBatDau.lng = null;
          } else {
            item.dia_diem.lat =
              this.mData.mapDataHanhTrinhDiaDiemBatDau.value[1];
            item.dia_diem.lng =
              this.mData.mapDataHanhTrinhDiaDiemBatDau.value[0];
          }
          if (!this.mData.dataPropMapHanhTrinhDiaDiemKetThuc.showMap) {
            item.dia_diem_dich.lat = null;
            item.dia_diem_dich.lng = null;
            this.mData.dataPropMapHanhTrinhDiaDiemKetThuc.lat = null;
            this.mData.dataPropMapHanhTrinhDiaDiemKetThuc.lng = null;
          } else {
            item.dia_diem_dich.lat =
              this.mData.mapDataHanhTrinhDiaDiemKetThuc.value[1];
            item.dia_diem_dich.lng =
              this.mData.mapDataHanhTrinhDiaDiemKetThuc.value[0];
          }
          console.log("item", item);
          this.mData.dataForm.hanh_trinh.splice(
            this.mData.dataDefault.HanhTrinh.indexModal,
            1,
            item
          );
          this.fn_resetFormHanhTrinh();
          this.mData.dialog.HanhTrinh = false;
          this.mData.timelineHanhTrinh.reloadNoiDung++;
          MethodService.stopLadda();
        });
      }
      if (type == "delete") {
        this.$confirm("Bạn có chắc chắn muốn xóa?", {
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Hủy",
          type: "warning",
        })
          .then(() => {
            this.mData.dataForm.hanh_trinh.splice(index, 1);
          })
          .catch(() => {});
      }
    },

    // Số lượng khách
    fn_soLuongKhachChanged() {
      if (!this.mData.dataForm.so_luong_khach.nguoi_lon)
        this.mData.dataForm.so_luong_khach.nguoi_lon = 0;
      if (!this.mData.dataForm.so_luong_khach.tre_5_15)
        this.mData.dataForm.so_luong_khach.tre_5_15 = 0;
      if (!this.mData.dataForm.so_luong_khach.tre_duoi_5)
        this.mData.dataForm.so_luong_khach.tre_duoi_5 = 0;
      this.mData.dataForm.so_luong_khach.so_luong =
        this.mData.dataForm.so_luong_khach.nguoi_lon +
        this.mData.dataForm.so_luong_khach.tre_5_15 +
        this.mData.dataForm.so_luong_khach.tre_duoi_5;
      if (this.mData.dataForm.so_luong_khach.so_luong === 0)
        this.mData.dataForm.so_luong_khach.so_luong = undefined;
      this.$refs["myForm"].validateField("so_luong_khach.so_luong");
    },

    // Khách sạn
    fn_handleKhachSan(type, index) {
      if (type == "create") {
        this.$refs["myFormKhachSan"].validate(async (valid) => {
          if (valid) {
            let item = MethodService.copyObject(this.mData.dataFormKhachSan);

            if (!this.mData.dataPropMapKhachSan.showMap) {
              item.dia_chi.lat = null;
              item.dia_chi.lng = null;
              this.mData.dataPropMapKhachSan.lat = null;
              this.mData.dataPropMapKhachSan.lng = null;
            } else {
              item.dia_chi.lat = this.mData.mapDataKhachSan.value[1];
              item.dia_chi.lng = this.mData.mapDataKhachSan.value[0];
            }
            this.mData.dataForm.khach_san.push(item);
            this.fn_resetFormKhachSan();
            this.mData.dialog.KhachSan = false;
            MethodService.stopLadda();
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
      if (type == "update") {
        this.$refs["myFormKhachSan"].validate(async (valid) => {
          if (valid) {
            let item = MethodService.copyObject(this.mData.dataFormKhachSan);
            if (!this.mData.dataPropMapKhachSan.showMap) {
              item.dia_chi.lat = null;
              item.dia_chi.lng = null;
              this.mData.dataPropMapKhachSan.lat = null;
              this.mData.dataPropMapKhachSan.lng = null;
            } else {
              item.dia_chi.lat = this.mData.mapDataKhachSan.value[1];
              item.dia_chi.lng = this.mData.mapDataKhachSan.value[0];
            }
            this.mData.dataForm.khach_san.splice(
              this.mData.dataDefault.KhachSan.indexModal,
              1,
              item
            );
            this.fn_resetFormKhachSan();
            this.mData.dialog.KhachSan = false;
            MethodService.stopLadda();
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
      if (type == "delete") {
        this.$confirm("Bạn có chắc chắn muốn xóa?", {
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Hủy",
          type: "warning",
        })
          .then(() => {
            this.mData.dataForm.khach_san.splice(index, 1);
          })
          .catch(() => {});
      }
    },

    // Nhà hàng
    fn_handleNhaHang(type, index) {
      if (type == "create") {
        this.$refs["myFormNhaHang"].validate(async (valid) => {
          if (valid) {
            let item = MethodService.copyObject(this.mData.dataFormNhaHang);
            if (!this.mData.dataPropMapNhaHang.showMap) {
              item.dia_chi.lat = null;
              item.dia_chi.lng = null;
              this.mData.dataPropMapNhaHang.lat = null;
              this.mData.dataPropMapNhaHang.lng = null;
            } else {
              item.dia_chi.lat = this.mData.mapDataNhaHang.value[1];
              item.dia_chi.lng = this.mData.mapDataNhaHang.value[0];
            }
            this.mData.dataForm.nha_hang.push(item);
            this.fn_resetFormNhaHang();
            this.mData.dialog.NhaHang = false;
            MethodService.stopLadda();
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
      if (type == "update") {
        this.$refs["myFormNhaHang"].validate(async (valid) => {
          if (valid) {
            let item = MethodService.copyObject(this.mData.dataFormNhaHang);
            if (!this.mData.dataPropMapNhaHang.showMap) {
              item.dia_chi.lat = null;
              item.dia_chi.lng = null;
              this.mData.dataPropMapNhaHang.lat = null;
              this.mData.dataPropMapNhaHang.lng = null;
            } else {
              item.dia_chi.lat = this.mData.mapDataNhaHang.value[1];
              item.dia_chi.lng = this.mData.mapDataNhaHang.value[0];
            }
            this.mData.dataForm.nha_hang.splice(
              this.mData.dataDefault.NhaHang.indexModal,
              1,
              item
            );

            this.fn_resetFormNhaHang();
            this.mData.dialog.NhaHang = false;
            MethodService.stopLadda();
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
      if (type == "delete") {
        this.$confirm("Bạn có chắc chắn muốn xóa?", {
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Hủy",
          type: "warning",
        })
          .then(() => {
            this.mData.dataForm.nha_hang.splice(index, 1);
          })
          .catch(() => {});
      }
    },

    fn_openModalHanhTrinh(type, id) {
      this.mData.dialog.HanhTrinh = true;
      this.mData.dataDefault.HanhTrinh.diaDiemMode = "one";
      this.data.type = "";
      this.mData.dataPropMapHanhTrinhDiaDiemBatDau.showMap = false;
      this.mData.dataPropMapHanhTrinhDiaDiemKetThuc.showMap = false;

      this.mData.dataDefault.thoiGianBatDauHanhTrinhErrorMessage =
        this.mData.dataDefault.thoiGianKetThucHanhTrinhErrorMessage = "";

      if (type == "create") {
        this.mData.dataDefault.HanhTrinh.indexModal = undefined;
        this.mData.dataDefault.HanhTrinh.viewMode = type;
        this.mData.dataFormHanhTrinh = MethodService.copyObject(
          TourModel.dataFormOther.hanh_trinh
        );
      } else {
        this.mData.dataDefault.HanhTrinh.indexModal = id;
        this.mData.dataDefault.HanhTrinh.viewMode = type;
        this.mData.dataFormHanhTrinh = MethodService.copyObject(
          this.mData.dataForm.hanh_trinh[id]
        );
        if (
          this.mData.dataFormHanhTrinh.dia_diem &&
          this.mData.dataFormHanhTrinh.dia_diem.lat &&
          this.mData.dataFormHanhTrinh.dia_diem.lng
        ) {
          this.mData.mapDataHanhTrinhDiaDiemBatDau.value[1] =
            this.mData.dataFormHanhTrinh.dia_diem.lat;
          this.mData.mapDataHanhTrinhDiaDiemBatDau.value[0] =
            this.mData.dataFormHanhTrinh.dia_diem.lng;
        }
        if (
          this.mData.dataFormHanhTrinh.dia_diem_dich &&
          this.mData.dataFormHanhTrinh.dia_diem_dich.lat &&
          this.mData.dataFormHanhTrinh.dia_diem_dich.lng
        ) {
          this.mData.mapDataHanhTrinhDiaDiemKetThuc.value[1] =
            this.mData.dataFormHanhTrinh.dia_diem_dich.lat;
          this.mData.mapDataHanhTrinhDiaDiemKetThuc.value[0] =
            this.mData.dataFormHanhTrinh.dia_diem_dich.lng;
        }
        if (this.mData.dataFormHanhTrinh.dia_diem_dich.dia_diem) {
          this.mData.dataDefault.HanhTrinh.diaDiemMode = "two";
        }
      }
      console.log("this.mData.dataFormHanhTrinh", this.mData.dataFormHanhTrinh);
      if (
        (this.mData.mapDataHanhTrinhDiaDiemBatDau.value[1] != 21.0287797 ||
          this.mData.mapDataHanhTrinhDiaDiemBatDau.value[0] != 105.850176) &&
        (this.mData.viewMode == "detail" ||
          this.mData.viewMode == "update" ||
          this.mData.viewMode == "create") &&
        type != "create"
      ) {
        this.mData.dataPropMapHanhTrinhDiaDiemBatDau.showMap = true;
      }
      if (
        (this.mData.viewMode == "create" || this.mData.viewMode == "update") &&
        type == "detail"
      ) {
        this.data.type = "detail";
        this.mData.dataPropMapHanhTrinhDiaDiemBatDau.type = "detail";
      }
      if (
        (this.mData.mapDataHanhTrinhDiaDiemKetThuc.value[1] != 21.0287797 ||
          this.mData.mapDataHanhTrinhDiaDiemKetThuc.value[0] != 105.850176) &&
        (this.mData.viewMode == "detail" ||
          this.mData.viewMode == "update" ||
          this.mData.viewMode == "create") &&
        type != "create"
      ) {
        this.mData.dataPropMapHanhTrinhDiaDiemKetThuc.showMap = true;
      }
      if (
        (this.mData.viewMode == "create" || this.mData.viewMode == "update") &&
        type == "detail"
      ) {
        this.data.type = "detail";
        this.mData.dataPropMapHanhTrinhDiaDiemKetThuc.type = "detail";
      }
    },

    fn_openModalKhachSan(type, id) {
      this.mData.dialog.KhachSan = true;
      this.mData.dataPropMapKhachSan.showMap = false;
      this.mData.dataPropMapKhachSan.type = "";
      if (type == "create") {
        this.mData.dataDefault.KhachSan.indexModal = undefined;
        this.mData.dataDefault.KhachSan.viewMode = type;
        this.mData.dataFormKhachSan = MethodService.copyObject(
          TourModel.dataFormOther.khach_san
        );
      } else {
        this.mData.dataDefault.KhachSan.indexModal = id;
        this.mData.dataDefault.KhachSan.viewMode = type;
        this.mData.dataFormKhachSan = MethodService.copyObject(
          this.mData.dataForm.khach_san[id]
        );
        if (
          this.mData.dataFormKhachSan.dia_chi &&
          this.mData.dataFormKhachSan.dia_chi.lat &&
          this.mData.dataFormKhachSan.dia_chi.lng
        ) {
          this.mData.mapDataKhachSan.value[1] =
            this.mData.dataFormKhachSan.dia_chi.lat;
          this.mData.mapDataKhachSan.value[0] =
            this.mData.dataFormKhachSan.dia_chi.lng;
        }
      }

      if (
        (this.mData.mapDataKhachSan.value[1] != 21.0287797 ||
          this.mData.mapDataKhachSan.value[0] != 105.850176) &&
        (this.mData.viewMode == "detail" || this.mData.viewMode == "update") &&
        type != "create"
      ) {
        this.mData.dataPropMapKhachSan.showMap = true;
      }
      if (
        (this.mData.viewMode == "create" || this.mData.viewMode == "update") &&
        type == "detail"
      ) {
        this.data.type = "detail";
        this.mData.dataPropMapKhachSan.type = "detail";
      }
    },

    fn_openModalNhaHang(type, id) {
      this.mData.dialog.NhaHang = true;
      this.mData.dataPropMapNhaHang.showMap = false;
      if (type == "create") {
        this.mData.dataDefault.NhaHang.indexModal = undefined;
        this.mData.dataDefault.NhaHang.viewMode = type;
        this.mData.dataFormNhaHang = MethodService.copyObject(
          TourModel.dataFormOther.nha_hang
        );
      } else {
        this.mData.dataDefault.NhaHang.indexModal = id;
        this.mData.dataDefault.NhaHang.viewMode = type;
        this.mData.dataFormNhaHang = MethodService.copyObject(
          this.mData.dataForm.nha_hang[id]
        );
        if (
          this.mData.dataFormNhaHang.dia_chi &&
          this.mData.dataFormNhaHang.dia_chi.lat &&
          this.mData.dataFormNhaHang.dia_chi.lng
        ) {
          this.mData.mapDataNhaHang.value[1] =
            this.mData.dataFormNhaHang.dia_chi.lat;
          this.mData.mapDataNhaHang.value[0] =
            this.mData.dataFormNhaHang.dia_chi.lng;
        }
      }
      if (
        (this.mData.mapDataNhaHang.value[1] != 21.0287797 ||
          this.mData.mapDataNhaHang.value[0] != 105.850176) &&
        (this.mData.viewMode == "detail" || this.mData.viewMode == "update") &&
        type != "create"
      ) {
        this.mData.dataPropMapNhaHang.showMap = true;
      }
      if (
        (this.mData.viewMode == "create" || this.mData.viewMode == "update") &&
        type == "detail"
      ) {
        this.data.type = "detail";
        this.mData.dataPropMapNhaHang.type = "detail";
      }
    },

    fn_formatterDate(row, column, cellValue) {
      if (cellValue) {
        return MethodService.formatDate(cellValue, "date");
      } else {
        return "Chưa có thông tin";
      }
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    //upload ảnh
    fn_uploadCheckFileSize(file, size) {
      return MethodService.checkFileSize(file, size);
    },

    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.anh.anh_dai_dien = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "tour")
        .then((res) => {
          this.mData.dataForm.anh.anh_dai_dien = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      window.toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },

    fn_uploadRemoveAnhTour(file, fileList) {
      let data = fileList.map((el) => el.id);
      this.mData.dataForm.anh.anh_tour = data;
    },
    fn_uploadChangeAnhTour(file, fileList) {
      ExtensionService.upload(file, "tour")
        .then((res) => {
          this.mData.dataForm.anh.anh_tour.push(res.result);

          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption.AnhTour.fileList = fileList;
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhTour() {
      window.toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhTour.limit} file`
      );
    },
    fn_uploadPreviewAnhTour(file) {
      this.mData.fileUploadOption.AnhTour.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhTour.dialogVisible = true;
    },

    fn_uploadRemoveHoSoTour(file, fileList) {
      let data = [];
      fileList.forEach((el) => {
        data.push(el.id);
      });
      this.mData.dataForm.scan.ho_so_tour = data;
    },
    fn_uploadChangeHoSoTour(file, fileList) {
      ExtensionService.upload(file, "tour")
        .then((res) => {
          this.mData.dataForm.scan.ho_so_tour.push(res.result);
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption.HoSoTour.fileList = fileList;
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedHoSoTour() {
      window.toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.HoSoTour.limit} file`
      );
    },
    fn_uploadPreviewHoSoTour(file) {
      this.mData.fileUploadOption.HoSoTour.dialogImageUrl = file.url;
      this.mData.fileUploadOption.HoSoTour.dialogVisible = true;
      window.open(ExtensionService.urlFile + file.id);
    },
    async fn_uploadChangeDsKhachDuLich(file) {
      let valueFile = await MethodService.readExcel(file.raw);
      if (valueFile.length > 1) {
        this.fn_formatExcelRow(valueFile);
      } else {
        window.toastr.error("Dữ liệu trong file trống");
      }
    },

    fn_formatExcelRow(valueFile) {
      // merge từ index excel sang tên code: value
      var arrKhachDuLich = [];
      valueFile.forEach((elFile, iFile) => {
        if (iFile == 0) return;

        let newObject = {};
        elFile.forEach((elFileItem, iFileItem) => {
          this.mData.excelKhachDuLich.configIndex.forEach((elModel) => {
            if (iFileItem == elModel.index) {
              newObject[elModel.code] = elFileItem;
            }
          });
        });
        arrKhachDuLich.push(newObject);
      });
      this.mData.dialogKhachDuLich.list = arrKhachDuLich;
      this.mData.dialogKhachDuLich.visible = true;
      this.mData.dialogKhachDuLich.hasError = false;
    },

    async fn_addValueKhachDuLich() {
      var arrNew = [];

      this.mData.dialogKhachDuLich.list.forEach((elKhach) => {
        let objNew = MethodService.copyObject(
          TourModel.excelKhachDuLich.formModel
        );

        // objNew.so_the = elKhach.excel_so_the;
        objNew.ho_ten.ho_ten = elKhach.excel_ho_ten;
        // objNew.ho_ten.ho=
        // objNew.ho_ten.ten=
        objNew.so_the = elKhach.excel_ma_ms;
        objNew.email = elKhach.excel_email;
        objNew.dien_thoai = elKhach.excel_dien_thoai;
        objNew.gioi_tinh = undefined;
        objNew.ngay_sinh.ngay = elKhach.excel_ngay_sinh;
        objNew.ngay_sinh.thang = elKhach.excel_thang_sinh;
        objNew.ngay_sinh.nam = elKhach.excel_nam_sinh;
        objNew.ngay_sinh.ngay_sinh = MethodService.formatDate(
          new Date(
            `${elKhach.excel_nam_sinh}-${elKhach.excel_thang_sinh}-${elKhach.excel_ngay_sinh}`
          ),
          ""
        );
        objNew.giay_to[0].loai_giay_to = elKhach.excel_loai_giay_to;
        objNew.giay_to[0].so_giay_to = elKhach.excel_so_giay_to;
        objNew.giay_to[0].noi_cap = elKhach.excel_noi_cap;

        if (
          elKhach.excel_nam_cap &&
          elKhach.excel_thang_cap &&
          elKhach.excel_ngay_cap
        ) {
          objNew.giay_to[0].ngay_cap = MethodService.formatDate(
            new Date(
              `${elKhach.excel_nam_cap}-${elKhach.excel_thang_cap}-${elKhach.excel_ngay_cap}`
            ),
            ""
          );
        }
        if (
          elKhach.excel_nam_het_han &&
          elKhach.excel_thang_het_han &&
          elKhach.excel_ngay_het_han
        ) {
          objNew.giay_to[0].ngay_het_han = MethodService.formatDate(
            new Date(
              `${elKhach.excel_nam_het_han}-${elKhach.excel_thang_het_han}-${elKhach.excel_ngay_het_han}`
            ),
            ""
          );
        }

        objNew.quoc_tich.quoc_tich_id = undefined;
        objNew.quoc_tich.ten_quoc_tich = elKhach.excel_ten_quoc_tich;
        objNew.dia_chi.province_id = undefined;
        objNew.dia_chi.province_name = elKhach.excel_province_name;
        objNew.dia_chi.district_id = undefined;
        objNew.dia_chi.district_name = undefined;
        objNew.dia_chi.dia_chi = elKhach.excel_dia_chi;

        let province = this.mData.dataDefault.listProvince.find((element) => {
          return element.name == elKhach.excel_province_name;
        });
        if (province) {
          objNew.dia_chi.province_id = province.id;
        }

        let gioiTinh = DataService.gioiTinh.find((element) => {
          return element.text == elKhach.excel_gioi_tinh;
        });
        if (gioiTinh) {
          objNew.gioi_tinh = gioiTinh.id;
        }

        arrNew.push(objNew);
      });

      if (this.mData.dataForm.id) {
        await mushroom.tour.importTouristsAsync({
          body: arrNew,
          params: { tourId: this.mData.dataForm.id },
        });
        this.mData.dialogKhachDuLich.visible = false;
        this.fn_getDataById(this.mData.dataForm.id);
      } else {
        if (this.mData.dataDefault.listKhachDuLichExcel) {
          this.mData.dataDefault.listKhachDuLichExcel =
            this.mData.dataDefault.listKhachDuLichExcel.concat(arrNew);
        } else {
          this.mData.dataDefault.listKhachDuLichExcel = arrNew;
        }
        this.mData.dialogKhachDuLich.visible = false;
        MethodService.stopLadda();
      }
    },
    fn_uploadExceedDsKhachDuLich() {
      window.toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.DsKhachDuLich.limit} file`
      );
    },

    fn_uploadRemoveThongTinDieuTour(file, fileList) {
      let data = fileList.map((el) => el.id);
      this.mData.dataForm.scan.thong_tin_dieu_tour = data;
    },
    fn_uploadChangeThongTinDieuTour(file, fileList) {
      ExtensionService.upload(file, "tour")
        .then((res) => {
          this.mData.dataForm.scan.thong_tin_dieu_tour.push(res.result);
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption.ThongTinDieuTour.fileList = fileList;
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedThongTinDieuTour() {
      window.toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.ThongTinDieuTour.limit} file`
      );
    },
    fn_uploadPreviewThongTinDieuTour(file) {
      this.mData.fileUploadOption.ThongTinDieuTour.dialogImageUrl = file.url;
      this.mData.fileUploadOption.ThongTinDieuTour.dialogVisible = true;
    },
    async fn_remoteGetListTruongDoan(query) {
      this.mData.dataDefault.textFindTruongDoan = query;
      this.mData.dataDefault.listTruongDoan = [];
    },
    async fn_enterFindTruongDoan() {
      if (!this.mData.dataDefault.textFindTruongDoan) {
        return;
      }
      let resKhachDuLichApi = await mushroom.khach_du_lich.listAsync({
        limit: 1000,
        filters: `so_the=${this.mData.dataDefault.textFindTruongDoan}`,
      });
      this.mData.dataDefault.listTruongDoan = resKhachDuLichApi.result;
    },
    async fn_remoteGetListTruongDoan2(query) {
      this.mData.dataDefault.textFindTruongDoan2 = query;
      this.mData.dataDefault.listTruongDoan2 = [];
    },
    async fn_enterFindTruongDoan2() {
      if (this.mData.dataDefault.textFindTruongDoan2) {
        let resKhachDuLichApi = await mushroom.khach_du_lich.listAsync({
          limit: 1000,
          filters: `giay_to.so_giay_to=${this.mData.dataDefault.textFindTruongDoan2}`,
        });
        this.mData.dataDefault.listTruongDoan2 = resKhachDuLichApi.result;
      }
    },
    fn_addTruongDoan(item) {
      if (item) {
        var flag = false;
        this.mData.dataDefault.listTruongDoanTable.forEach((element) => {
          if (item.id == element.id) {
            flag = true;
          }
        });
        if (flag) {
          window.toastr.info("Đã tồn tại trưởng đoàn này!");
        } else {
          this.mData.dataDefault.listTruongDoanTable = [];
          this.mData.dataDefault.listTruongDoanTable.push(item);
          this.mData.dataForm.truong_doan.truong_doan_id = item.id;
        }

        this.mData.dataDefault.itemTruongDoan = null;
        this.mData.dataDefault.listTruongDoan = [];
        this.mData.dataDefault.itemTruongDoan2 = null;
        this.mData.dataDefault.listTruongDoan2 = [];
      }
    },
    fn_deleteTruongDoan(index) {
      this.$confirm("Bạn có chắc chắn muốn xóa?", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.mData.dataDefault.listTruongDoanTable.splice(index, 1);
          this.mData.dataForm.truong_doan.truong_doan_id = null;
          this.fn_setTruongDoanStatus(
            this.mData.dataDefault.listKhachDuLichTable,
            this.mData.dataForm.truong_doan.truong_doan_id
          );
          this.fn_setTruongDoanStatus(
            this.mData.dataDefault.listKhachDuLichDaXacNhanTable,
            this.mData.dataForm.truong_doan.truong_doan_id
          );
          this.fn_setTruongDoanStatus(
            this.mData.dataDefault.listKhachDuLichKhongTaiKhoanTable,
            this.mData.dataForm.truong_doan.truong_doan_id
          );
        })
        .catch(() => {});
    },
    async fn_remoteGetListKhachDuLich(query) {
      this.mData.dataDefault.textFindKhachDuLich = query;
      this.mData.dataDefault.listKhachDuLich = [];
    },
    async fn_enterFindKhachDuLich() {
      // let filter = '';
      // if(this.mData.dataDefault.textFindKhachDuLich.substr(0,1)=="0" && this.mData.dataDefault.textFindKhachDuLich.length==10){
      //   filter = `so_the=${this.mData.dataDefault.textFindKhachDuLich}|so_the=${"84"+this.mData.dataDefault.textFindKhachDuLich.substring(1)}`;
      // let resKhachDuLichApi = await KhachDuLichApi.list({
      //   limit: 1000,
      //   filters: filter
      // });
      // if (resKhachDuLichApi.result && resKhachDuLichApi.result.length) {
      //   this.mData.dataDefault.listKhachDuLich = resKhachDuLichApi.result;
      // } else {
      //   this.fn_addKhachDuLichKhongCoThe(
      //     this.mData.dataDefault.textFindKhachDuLich
      //   );
      // }

      //   let resKhachDuLichApi = await AccountApi.getUserIdOrFetchAcsUser({"cardCode":this.mData.dataDefault.textFindKhachDuLich});
      //   if (resKhachDuLichApi.result) {
      //     this.mData.dataDefault.listKhachDuLich = resKhachDuLichApi.result;
      //   } else {
      //     this.fn_addKhachDuLichKhongCoThe(
      //       this.mData.dataDefault.textFindKhachDuLich
      //     );
      //   }

      // }

      if (this.mData.dataDefault.textFindKhachDuLich) {
        this.mData.dataDefault.textFindKhachDuLich =
          this.mData.dataDefault.textFindKhachDuLich.trim();
        // let resKhachDuLichApi = await mushroom.khach_du_lich.listAsync({
        //   limit: 1000,
        //   filters: `so_the=${this.mData.dataDefault.textFindKhachDuLich}`
        // });
        // if (resKhachDuLichApi.result && resKhachDuLichApi.result.length) {
        //   this.mData.dataDefault.listKhachDuLich = resKhachDuLichApi.result;
        // } else {
        //   this.fn_addKhachDuLichKhongCoThe(
        //     this.mData.dataDefault.textFindKhachDuLich
        //   );
        // }

        let resKhachDuLichApi =
          await mushroom.user.getUserIdOrFetchAcsUserAsync({
            body: { cardCode: this.mData.dataDefault.textFindKhachDuLich },
          });
        if (resKhachDuLichApi.result) {
          let khachDuLichApiResult = await mushroom.khach_du_lich.findByIdAsync(
            {
              id: resKhachDuLichApi.result,
            }
          );
          this.mData.dataDefault.listKhachDuLich.push(
            khachDuLichApiResult.result
          );
        } else {
          debugger;
          this.fn_addKhachDuLichKhongCoThe(
            this.mData.dataDefault.textFindKhachDuLich
          );
        }
      }
    },
    async fn_addKhachDuLichKhongCoThe(soThe) {
      var flag = false;
      this.mData.dataDefault.listKhachDuLichKhongTaiKhoanTable.forEach(
        (element) => {
          if (soThe == element.so_the) {
            flag = true;
          }
        }
      );
      if (flag) {
        window.toastr.info("Đã tồn tại khách du lịch này");
      } else {
        let resActive = await mushroom.$auth.checkActiveAsync(
          this.mData.dataDefault.textFindKhachDuLich
        );

        if (resActive.result) {
          let resAdd = await mushroom.tour.addTouristByCardCodeAsync({
            params: {
              tourId: this.mData.dataForm.id,
              cardCode: this.mData.dataDefault.textFindKhachDuLich,
            },
          });
          this.mData.dataDefault.listKhachDuLich = resAdd;
        } else {
          if (!resActive.meta) {
            let resAdd = await mushroom.tour.addTouristByCardCodeAsync({
              params: {
                tourId: this.mData.dataForm.id,
                cardCode: this.mData.dataDefault.textFindKhachDuLich,
              },
            });
            window.toastr.success(
              "Thêm khách du lịch chưa có tài khoản thành công"
            );
            this.mData.dataDefault.listKhachDuLichKhongTaiKhoanTable.push(
              resAdd.result
            );
          }
        }
      }
    },
    async fn_remoteGetListKhachDuLich2(query) {
      this.mData.dataDefault.textFindKhachDuLich2 = query;
      this.mData.dataDefault.listKhachDuLich2 = [];
    },
    async fn_enterFindKhachDuLich2() {
      if (this.mData.dataDefault.textFindKhachDuLich2) {
        this.mData.dataDefault.textFindKhachDuLich2 =
          this.mData.dataDefault.textFindKhachDuLich2.trim();
        let resKhachDuLichApi = await mushroom.khach_du_lich.listAsync({
          limit: 1000,
          filters: `giay_to.so_giay_to=${this.mData.dataDefault.textFindKhachDuLich2}`,
        });
        this.mData.dataDefault.listKhachDuLich2 = resKhachDuLichApi.result;
      }
    },

    fn_addKhachDuLich(item) {
      if (item) {
        var flag = false;
        this.mData.dataDefault.listKhachDuLichTable.forEach((element) => {
          if (item.id == element.id) {
            flag = true;
          }
        });
        this.mData.dataDefault.listKhachDuLichDaXacNhanTable.forEach(
          (element) => {
            if (item.id == element.id) {
              flag = true;
            }
          }
        );
        if (flag) {
          window.toastr.info("Đã tồn tại khách du lịch này");
        } else {
          if (item.id) {
            if (
              item.ho_ten &&
              item.ho_ten.ho_ten &&
              item.ho_ten.ho_ten.trim() != ""
            ) {
              item.ho_ten.ho_ten = item.ho_ten.ho_ten;
            } else {
              item.ho_ten = {
                ho_ten: "Chưa có thông tin",
              };
            }
            if (!item.email) {
              item.email = "Chưa có thông tin";
            }
            this.mData.dataDefault.listKhachDuLichTable.push(item);
            if (!this.mData.dataForm.khach_du_lich_cho_xac_nhan_ids) {
              this.mData.dataForm.khach_du_lich_cho_xac_nhan_ids = [];
            }
            this.mData.dataForm.khach_du_lich_cho_xac_nhan_ids.push(item.id);
          }
        }

        this.mData.dataDefault.itemKhachDuLich = null;
        this.mData.dataDefault.listKhachDuLich = [];
      }
    },
    fn_addKhachDuLich2(item) {
      if (item) {
        var flag = false;
        this.mData.dataDefault.listKhachDuLichTable.forEach((element) => {
          if (item.id == element.id) {
            flag = true;
          }
        });
        this.mData.dataDefault.listKhachDuLichDaXacNhanTable.forEach(
          (element) => {
            if (item.id == element.id) {
              flag = true;
            }
          }
        );
        if (flag) {
          window.toastr.info("Đã tồn tại khách du lịch này");
        } else {
          if (item.id) {
            if (
              item.ho_ten &&
              item.ho_ten.ho_ten &&
              item.ho_ten.ho_ten.trim() != ""
            ) {
              item.ho_ten.ho_ten = item.ho_ten.ho_ten;
            } else {
              item.ho_ten = {
                ho_ten: "Chưa có thông tin",
              };
            }
            if (!item.email) {
              item.email = "Chưa có thông tin";
            }
            this.mData.dataDefault.listKhachDuLichTable.push(item);
            if (!this.mData.dataForm.khach_du_lich_cho_xac_nhan_ids) {
              this.mData.dataForm.khach_du_lich_cho_xac_nhan_ids = [];
            }
            this.mData.dataForm.khach_du_lich_cho_xac_nhan_ids.push(item.id);
          }
        }

        this.mData.dataDefault.itemKhachDuLich2 = null;
        this.mData.dataDefault.listKhachDuLich2 = [];
      }
    },

    fn_selectTruongDoan(id) {
      if (!id) {
        window.toastr.warning(
          "Bạn không thể chọn khách du lịch chưa có thẻ làm trưởng đoàn"
        );
        return;
      }
      let c_confirm = "";
      if (this.mData.dataForm.truong_doan.truong_doan_id == id) {
        c_confirm = "Bạn có chắc chắn muốn bỏ chọn trưởng đoàn?";
      } else {
        c_confirm = "Bạn có chắc chắn muốn chọn làm trưởng đoàn?";
      }
      this.$confirm(c_confirm, {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          if (this.mData.dataForm.truong_doan.truong_doan_id == id) {
            window.toastr.success("Bỏ chọn trưởng đoàn thành công!");
            this.mData.dataForm.truong_doan.truong_doan_id = null;
          } else {
            window.toastr.success("Chọn trưởng đoàn thành công!");
            this.mData.dataForm.truong_doan.truong_doan_id = id;
          }

          this.fn_setTruongDoanStatus(
            this.mData.dataDefault.listKhachDuLichTable,
            this.mData.dataForm.truong_doan.truong_doan_id
          );
          this.fn_setTruongDoanStatus(
            this.mData.dataDefault.listKhachDuLichDaXacNhanTable,
            this.mData.dataForm.truong_doan.truong_doan_id
          );
          this.fn_setTruongDoanStatus(
            this.mData.dataDefault.listKhachDuLichKhongTaiKhoanTable,
            this.mData.dataForm.truong_doan.truong_doan_id
          );
          console.log(
            "this.mData.dataDefault.listKhachDuLichTable",
            this.mData.dataDefault.listKhachDuLichTable
          );
        })
        .catch(() => {});
    },
    fn_deleteKhachDuLich(index) {
      this.$confirm("Bạn có chắc chắn muốn xóa?", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          var itemDel = this.mData.dataDefault.listKhachDuLichTable[index];
          this.mData.dataDefault.listKhachDuLichTable.splice(index, 1);
          this.mData.dataForm.khach_du_lich_cho_xac_nhan_ids.forEach(
            (item, i) => {
              if (itemDel.id == item) {
                this.mData.dataForm.khach_du_lich_cho_xac_nhan_ids.splice(i, 1);
                return false; // breaks
              }
            }
          );
          this.mData.dataForm.danh_sach_khach_du_lich_khong_tai_khoan.forEach(
            (item, i) => {
              if (itemDel.key == item.key) {
                this.mData.dataForm.danh_sach_khach_du_lich_khong_tai_khoan.splice(
                  i,
                  1
                );
                return false; // breaks
              }
            }
          );
          console.log(
            "this.mData.dataForm.danh_sach_khach_du_lich_khong_tai_khoan",
            this.mData.dataForm.danh_sach_khach_du_lich_khong_tai_khoan
          );
          if (itemDel.id == this.mData.dataForm.truong_doan.truong_doan_id) {
            this.mData.dataDefault.listTruongDoanTable.splice(index, 1);
            this.mData.dataForm.truong_doan.truong_doan_id = null;
          }
        })
        .catch(() => {});
    },
    fn_deleteKhachDuLichDaXacNhan(index) {
      this.$confirm("Bạn có chắc chắn muốn xóa?", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(async () => {
          var itemDel =
            this.mData.dataDefault.listKhachDuLichDaXacNhanTable[index];
          this.mData.dataForm.khach_du_lich_ids.forEach((item, i) => {
            if (itemDel.id == item) {
              this.mData.dataForm.khach_du_lich_ids.splice(i, 1);
              return false; // breaks
            }
          });
          await mushroom.tour.removeKhachDuLichAsync({
            params: {
              tourId: this.$router.currentRoute.params.id,
              userId: itemDel.id,
            },
          });
          this.mData.dataDefault.listKhachDuLichDaXacNhanTable.splice(index, 1);
        })
        .catch(() => {});
    },
    fn_deleteKhachDuLichChuaCoTK(index) {
      this.$confirm("Bạn có chắc chắn muốn xóa?", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(async () => {
          var itemDel =
            this.mData.dataDefault.listKhachDuLichKhongTaiKhoanTable[index];

          this.mData.dataForm.danh_sach_khach_du_lich_khong_tai_khoan.forEach(
            (item, i) => {
              if (itemDel == item) {
                this.mData.dataForm.danh_sach_khach_du_lich_khong_tai_khoan.splice(
                  i,
                  1
                );
                return false; // breaks
              }
            }
          );

          // await TourApi.removeKhachDuLich(
          //   this.$router.currentRoute.params.id,
          //   itemDel.id
          // );

          this.mData.dataDefault.listKhachDuLichKhongTaiKhoanTable.splice(
            index,
            1
          );
        })
        .catch(() => {});
    },
    fn_deleteKhachDuLichExcel(index) {
      this.$confirm("Bạn có chắc chắn muốn xóa?", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(async () => {
          var itemDel = this.mData.dataDefault.listKhachDuLichExcel[index];

          // $.each(
          //   this.mData.dataForm.danh_sach_khach_du_lich_khong_tai_khoan,
          //   (i, item) => {
          //     if (itemDel == item) {
          //       this.mData.dataForm.danh_sach_khach_du_lich_khong_tai_khoan.splice(
          //         i,
          //         1
          //       );
          //       return false; // breaks
          //     }
          //   }
          // );

          // await TourApi.removeKhachDuLich(
          //   this.$router.currentRoute.params.id,
          //   itemDel.id
          // );

          this.mData.dataDefault.listKhachDuLichExcel.splice(index, 1);
        })
        .catch(() => {});
    },
    fn_addLatLngDiaDiem(lat, lng) {
      this.mData.dataForm.dia_diem.lat = lat;
      this.mData.dataForm.dia_diem.lng = lng;
    },
    fn_addLatLngHanhTrinhDiaDiemBatDau(lat, lng) {
      this.mData.dataFormHanhTrinh.dia_diem.lat = lat;
      this.mData.dataFormHanhTrinh.dia_diem.lng = lng;
    },
    fn_addLatLngHanhTrinhDiaDiemKetThuc(lat, lng) {
      this.mData.dataFormHanhTrinh.dia_diem_dich.lat = lat;
      this.mData.dataFormHanhTrinh.dia_diem_dich.lng = lng;
    },
    fn_addLatLngKhachSan(lat, lng) {
      this.mData.dataFormKhachSan.dia_chi.lat = lat;
      this.mData.dataFormKhachSan.dia_chi.lng = lng;
    },
    fn_addLatLngNhaHang(lat, lng) {
      this.mData.dataFormNhaHang.dia_chi.lat = lat;
      this.mData.dataFormNhaHang.dia_chi.lng = lng;
    },
    fn_addLatLngViTriHDV(lat, lng) {},
    fn_formatterTableExcelKhachDuLich(colName, colVal, colVal2, colVal3) {
      if (colName == "excel_ho_ten") {
        if (!colVal) {
          this.mData.dialogKhachDuLich.hasError = true;
          return "bg-danger bg-column";
        }
      }
      if (colName == "excel_dien_thoai") {
        if (colVal && !MethodService.checkSDT(colVal)) {
          this.mData.dialogKhachDuLich.hasError = true;
          return "bg-danger bg-column";
        }
      }
      if (colName == "excel_so_the") {
        if (colVal && colVal.length != 9 && colVal.length != 16) {
          this.mData.dialogKhachDuLich.hasError = true;
          return "bg-danger bg-column";
        }
      }
      if (colName == "excel_ngay_sinh") {
        //colVal = ngay, colVal2 = thang, colVal3 = nam
        if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
          this.mData.dialogKhachDuLich.hasError = true;
          return "bg-danger bg-column";
        }
      }
      if (colName == "excel_thang_sinh") {
        if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
          this.mData.dialogKhachDuLich.hasError = true;
          return "bg-danger bg-column";
        }
      }
      if (colName == "excel_nam_sinh") {
        if (!colVal) {
          this.mData.dialogKhachDuLich.hasError = true;
          return "bg-danger bg-column";
        }
      }
      if (colName == "excel_ngay_cap") {
        //
        //colVal = ngay, colVal2 = thang, colVal3 = nam
        if (colVal != null) {
          if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
            this.mData.dialogKhachDuLich.hasError = true;
            return "bg-danger bg-column";
          }
        }
      }
      if (colName == "excel_thang_cap") {
        if (colVal2 != null) {
          if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
            this.mData.dialogKhachDuLich.hasError = true;
            return "bg-danger bg-column";
          }
        }
      }
      if (colName == "excel_nam_cap") {
        if (colVal3 != null) {
          if (!colVal) {
            this.mData.dialogKhachDuLich.hasError = true;
            return "bg-danger bg-column";
          }
        }
      }
      if (colName == "excel_ngay_het_han") {
        //colVal = ngay, colVal2 = thang, colVal3 = nam
        if (colVal != null) {
          if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
            this.mData.dialogKhachDuLich.hasError = true;
            return "bg-danger bg-column";
          }
        }
      }
      if (colName == "excel_thang_het_han") {
        if (colVal2 != null) {
          if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
            this.mData.dialogKhachDuLich.hasError = true;
            return "bg-danger bg-column";
          }
        }
      }
      if (colName == "excel_nam_het_han") {
        if (colVal3 != null) {
          if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
            this.mData.dialogKhachDuLich.hasError = true;
            return "bg-danger bg-column";
          }
        }
      }
    },
    fn_clickTab(tab) {
      this.tab.activeTab = tab;
      let id = this.$router.currentRoute.query.id
        ? this.$router.currentRoute.query.id
        : "";
      this.$router
        .replace({
          name: "Admin-" + this.mData.moduleName + "-" + this.mData.viewMode,
          query: {
            activeTab: tab,
            id: id,
          },
        })
        .catch(() => {});
    },
    fn_validateTourTime() {
      let timeStart = this.mData.dataForm.thoi_gian_bat_dau;
      let timeEnd = this.mData.dataForm.thoi_gian_ket_thuc;
      this.mData.dataDefault.tourTimeErrorMessage = "";
      if (timeStart && timeEnd) {
        let tourStartTime = new Date(timeStart).getTime();
        let tourEndTime = new Date(timeEnd).getTime();
        if (tourStartTime >= tourEndTime) {
          this.mData.dataDefault.tourTimeErrorMessage =
            "Giá trị trường Thời gian bắt đầu cần nhỏ hơn trường Thời gian kết thúc";
          return "";
        }

        if (Array.isArray(this.mData.dataForm.hanh_trinh)) {
          this.mData.dataForm.hanh_trinh.forEach((ht) => {
            if (
              ht.thoi_gian_bat_dau &&
              new Date(ht.thoi_gian_bat_dau).getTime() < tourStartTime
            ) {
              this.mData.dataDefault.tourTimeErrorMessage =
                "Thời gian bắt đầu tour đang lớn hơn Thời gian bắt đầu hành trình";
              return "";
            }

            if (
              ht.thoi_gian_ket_thuc &&
              new Date(ht.thoi_gian_ket_thuc).getTime() > tourEndTime
            ) {
              this.mData.dataDefault.tourTimeErrorMessage =
                "Thời gian kết thúc tour đang nhỏ hơn Thời gian kết thúc hành trình";
              return "";
            }
          });
        }
      }

      return "";
    },
    fn_validateHanhTrinhTime(type) {
      let hanhTrinhStartTime = 0,
        hanhTrinhEndTime = 0;
      if (this.mData.dataFormHanhTrinh.thoi_gian_bat_dau)
        hanhTrinhStartTime = new Date(
          this.mData.dataFormHanhTrinh.thoi_gian_bat_dau
        ).getTime();
      if (this.mData.dataFormHanhTrinh.thoi_gian_ket_thuc)
        hanhTrinhEndTime = new Date(
          this.mData.dataFormHanhTrinh.thoi_gian_ket_thuc
        ).getTime();

      if (
        hanhTrinhStartTime &&
        hanhTrinhEndTime &&
        hanhTrinhStartTime >= hanhTrinhEndTime
      ) {
        this.mData.dataDefault.thoiGianBatDauHanhTrinhErrorMessage =
          this.mData.dataDefault.thoiGianKetThucHanhTrinhErrorMessage =
            "Giá trị trường Thời gian bắt đầu cần nhỏ hơn trường Thời gian kết thúc";
        return "";
      }

      let tourStartTime = new Date(
        this.mData.dataForm.thoi_gian_bat_dau
      ).getTime();
      let tourEndTime = new Date(
        this.mData.dataForm.thoi_gian_ket_thuc
      ).getTime();

      if (hanhTrinhStartTime && type == "from") {
        if (
          tourStartTime &&
          this.mData.dataForm.thoi_gian_bat_dau &&
          hanhTrinhStartTime < tourStartTime
        ) {
          this.mData.dataDefault.thoiGianBatDauHanhTrinhErrorMessage =
            "Giá trị Thời gian bắt đầu của hành trình không được trước Thời gian bắt đầu của tour";
          return "";
        }
        if (tourEndTime && hanhTrinhStartTime > tourEndTime) {
          this.mData.dataDefault.thoiGianBatDauHanhTrinhErrorMessage =
            "Giá trị Thời gian bắt đầu của hành trình không được sau Thời gian kết thúc của tour";
          return "";
        }
        this.mData.dataDefault.thoiGianBatDauHanhTrinhErrorMessage = "";
      }

      if (hanhTrinhEndTime && type == "to") {
        if (tourStartTime && hanhTrinhEndTime < tourStartTime) {
          this.mData.dataDefault.thoiGianKetThucHanhTrinhErrorMessage =
            "Giá trị Thời gian kết thúc của hành trình không được trước Thời gian bắt đầu của tour";
          return "";
        }
        if (tourEndTime && hanhTrinhEndTime > tourEndTime) {
          this.mData.dataDefault.thoiGianKetThucHanhTrinhErrorMessage =
            "Giá trị Thời gian kết thúc của hành trình không được sau Thời gian kết thúc của tour";
          return "";
        }
        this.mData.dataDefault.thoiGianKetThucHanhTrinhErrorMessage = "";
      }

      return "";
    },
    fn_changeDiaDiem(val) {
      if (val == "one") {
        this.$set(this.mData.validFormHanhTrinh, "dia_diem_dich.dia_diem", []);
      } else {
        this.$set(this.mData.validFormHanhTrinh, "dia_diem_dich.dia_diem", [
          ValidService.required,
        ]);
      }
    },
    async fn_openModalViTriHDV(type, id_user, name_user) {
      this.mData.dialogViTriHDV.visible = true;
      this.mData.dialogViTriHDV.title = name_user;
      let res = await mushroom.location.listAsync({
        filters: "user_id=" + id_user,
      });

      if (res.result) {
        this.mData.dataPropMapViTriHDV.lng = res.result[0].loc.coordinates[0];
        this.mData.dataPropMapViTriHDV.lat = res.result[0].loc.coordinates[1];
        this.mData.dataPropMapViTriHDV.updateLastTime =
          res.result[0].created_time;
      }
      this.mData.dataPropMapViTriHDV.reload++;
    },
    fn_getDataFromMapDiaDiem(value) {
      // console.log(value);
      this.mData.mapDataDiaDiem = value;
    },
    fn_getDataFromMapHanhTrinhDiaDiemBatDau(value) {
      console.log("Bắt đầu", value);
      this.mData.mapDataHanhTrinhDiaDiemBatDau = value;
    },
    fn_getDataFromMapHanhTrinhDiaDiemKetThuc(value) {
      console.log("Kết thúc", value);
      this.mData.mapDataHanhTrinhDiaDiemKetThuc = value;
    },
    fn_getDataFromMapKhachSan(value) {
      // console.log(value);
      this.mData.mapDataKhachSan = value;
    },
    fn_getDataFromMapNhaHang(value) {
      // console.log(value);
      this.mData.mapDataNhaHang = value;
    },
    fn_getDataFromMapViTriHDV(value) {
      // console.log(value);
      this.mData.mapDataViTriHDV = value;
    },
  },
  created: function () {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.data = {
        viewMode: "update",
        type: "",
      };
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.data = {
        viewMode: "detail",
        type: "",
      };
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);

      if (
        this.$router.currentRoute.name ==
        "Admin-" + this.mData.moduleName + "-create"
      ) {
        this.data = {
          viewMode: "create",
          type: "",
        };
        this.mData.viewModeDuplicate = true;
        this.fn_changeDataDefault();
      }
    }
    if (this.$router.currentRoute.query.id) {
      this.fn_getDataById(this.$router.currentRoute.query.id);

      if (
        this.$router.currentRoute.name ==
        "Admin-" + this.mData.moduleName + "-create"
      ) {
        this.mData.viewModeDuplicate = true;
        this.fn_changeDataDefault();
      }
    }
    if (this.$router.currentRoute.query.activeTab) {
      this.tab.activeTab = this.$router.currentRoute.query.activeTab;
    }
  },
};
</script>
